/* eslint-disable */

import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import moment from 'moment';
import client from '../../api/client';
import ButtonGoto from '../../components/buttongoto/ButtonGoto';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import Policy from './Policy';
import { setLocalToken, getLocalToken, removeLocalToken } from '../../helper/storageHelper';

import './overlay.css';
import './signup.css';

const REGISTER_AUTH_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'multipart/form-data;',
  Authorization: 'Basic ' + btoa('Hvqhzd3f_zAXSsK7x2QfslGn0EvBoj'),
};

const EMPTY_ARRAY = [];

function Login(props) {
  const [remember_me, setRemember_me] = useState({
    rem: false,
    user: '',
    pass: '',
  });

  const [policy_read, setPolicy_read] = useState(false);

  // Real-time Validation States
  const [email_status, setEmail_status] = useState('idle');
  const [email_msg, setEmail_msg] = useState('');
  const [password_status, setPassword_status] = useState('idle');
  const [password_msg, setPassword_msg] = useState('');
  const [confirm_status, setConfirm_status] = useState('idle');
  const [confirm_msg, setConfirm_msg] = useState('');
  const [signup_password_val, setSignup_password_val] = useState('');
  const [showSuccessOptionModal, setShowSuccessOptionModal] = useState(false);

  // Drag & Drop File Upload States
  const [docFiles, setDocFiles] = useState({
    file1: null,
    file2: null,
    file3: null,
    file4: null,
  });
  const [docPreviews, setDocPreviews] = useState({
    file1: null,
    file2: null,
    file3: null,
    file4: null,
  });
  const [dragActive, setDragActive] = useState({
    file1: false,
    file2: false,
    file3: false,
    file4: false,
  });

  // Login Pending Validation & Completion Wizard States
  const [showLoginPendingModal, setShowLoginPendingModal] = useState(false);
  const [pendingModalMode, setPendingModalMode] = useState('warning'); // 'warning', 'wizard'
  const [wizardStep, setWizardStep] = useState(1);
  const [pendingUserInfo, setPendingUserInfo] = useState(null);

  // Wizard fields
  const [wizard_shop_name, setWizard_shop_name] = useState('');
  const [wizard_shop_address, setWizard_shop_address] = useState('');
  const [wizard_shop_telno, setWizard_shop_telno] = useState('');
  const [wizard_phone_format, setWizard_phone_format] = useState('');
  const [wizard_permit_type_selected, setWizard_permit_type_selected] = useState('');

  // Wizard address selects
  const [wizard_select_province, setWizard_select_province] = useState('');
  const [wizard_select_amphur, setWizard_select_amphur] = useState('');
  const [wizard_select_tambol, setWizard_select_tambol] = useState('');
  const [wizard_select_postcode, setWizard_select_postcode] = useState('');

  // Wizard files
  const [wizardDocFiles, setWizardDocFiles] = useState({
    file1: null,
    file2: null,
    file3: null,
    file4: null,
  });
  const [wizardDocPreviews, setWizardDocPreviews] = useState({
    file1: null,
    file2: null,
    file3: null,
    file4: null,
  });
  const [wizardDragActive, setWizardDragActive] = useState({
    file1: false,
    file2: false,
    file3: false,
    file4: false,
  });
  const [activeDocTab, setActiveDocTab] = useState('file1');
  const [wizardActiveDocTab, setWizardActiveDocTab] = useState('file1');

  const [phone_format, setPhone_format] = useState('');
  const [otp_phone_format, setOtp_phone_format] = useState('');
  const [otp_code_format, setOtp_code_format] = useState('');
  const [otp_refcode, setOtp_refcode] = useState('');
  const [otp_expire, setOtp_expire] = useState('');

  const [select_province, setSelect_province] = useState('');
  const [select_amphur, setSelect_amphur] = useState('');
  const [select_tambol, setSelect_tambol] = useState('');
  const [select_postcode, setSelect_postcode] = useState('');
  const [permit_type_selected, setPermit_type_selected] = useState('');

  const { data: list_province_data } = useQuery({
    queryKey: ['address-province'],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', 'all');
      const response = await client.post('/api/account/register/address/getprovince', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getprovince failed');
      }
      return response.data.data_province;
    },
    staleTime: Infinity,
  });
  const list_province = list_province_data ?? EMPTY_ARRAY;

  const { data: list_amphur_data } = useQuery({
    queryKey: ['address-amphur', select_province],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', select_province);
      const response = await client.post('/api/account/register/address/getamphure', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getamphure failed');
      }
      return response.data.data_amphure;
    },
    enabled: select_province !== '',
  });
  const list_amphur = list_amphur_data ?? EMPTY_ARRAY;

  const { data: list_tambol_data } = useQuery({
    queryKey: ['address-tambol', select_province, select_amphur],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', select_province);
      formData.append('amphur', select_amphur);
      const response = await client.post('/api/account/register/address/gettambol', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'gettambol failed');
      }
      return response.data.data_tambol;
    },
    enabled: select_amphur !== '',
  });
  const list_tambol = list_tambol_data ?? EMPTY_ARRAY;

  const { data: wizard_list_amphur_data } = useQuery({
    queryKey: ['address-amphur', wizard_select_province],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', wizard_select_province);
      const response = await client.post('/api/account/register/address/getamphure', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getamphure failed');
      }
      return response.data.data_amphure;
    },
    enabled: wizard_select_province !== '',
  });
  const wizard_list_amphur = wizard_list_amphur_data ?? EMPTY_ARRAY;

  const { data: wizard_list_tambol_data } = useQuery({
    queryKey: ['address-tambol', wizard_select_province, wizard_select_amphur],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', wizard_select_province);
      formData.append('amphur', wizard_select_amphur);
      const response = await client.post('/api/account/register/address/gettambol', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'gettambol failed');
      }
      return response.data.data_tambol;
    },
    enabled: wizard_select_amphur !== '',
  });
  const wizard_list_tambol = wizard_list_tambol_data ?? EMPTY_ARRAY;

  // Pre-auth account mutations — share the Basic-auth header above (no user session yet).
  const checkEmailMutation = useMutation({
    mutationFn: async (formData) => {
      const response = await client.post('/api/account/register/checkemail', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      return response.data;
    },
  });

  const otpRequestMutation = useMutation({
    mutationFn: async (formData) => {
      const response = await client.post('/api/account/register/otprequest', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      return response.data;
    },
  });

  const shopSigninMutation = useMutation({
    mutationFn: async (formData) => {
      const response = await client.post('/api/account/auth/shop_signin', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      return response.data;
    },
  });

  const submitAccountMutation = useMutation({
    mutationFn: async (formData) => {
      const response = await client.post('/api/account/register/submitaccount', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      return response.data;
    },
  });

  const sortedProvinces = useMemo(() => {
    try {
      return list_province.slice().sort((a, b) => a.localeCompare(b, 'th'));
    } catch (e) {
      return list_province.slice().sort();
    }
  }, [list_province]);

  const [box_policy, setBox_policy] = useState(false);
  const [box_forgot, setBox_forgot] = useState(false);
  const [box_signin, setBox_signin] = useState(false);
  const [box_signup, setBox_signup] = useState(false);
  const [box_signup_step, setBox_signup_step] = useState(1);
  const [box_signup_doc, setBox_signup_doc] = useState(false);
  const [box_signup_docemail, setBox_signup_docemail] = useState('');
  const [box_signup_docshopid, setBox_signup_docshopid] = useState('');
  const [box_signup_doctoken, setBox_signup_doctoken] = useState('');
  const [box_signup_submit, setBox_signup_submit] = useState(false);
  const [box_signup_next, setBox_signup_next] = useState(true);
  const [box_signup_previous, setBox_signup_previous] = useState(false);
  const [box_signup_haveaccount, setBox_signup_haveaccount] = useState(true);
  const [box_signup_time, setBox_signup_time] = useState(new Date());

  const [box_signup_stylep1, setBox_signup_stylep1] = useState({ display: 'block' });
  const [box_signup_stylep2, setBox_signup_stylep2] = useState({ display: 'none' });
  const [box_signup_stylep3, setBox_signup_stylep3] = useState({ display: 'none' });
  const [box_signup_stylep4, setBox_signup_stylep4] = useState({ display: 'none' });
  const [box_signup_stylep5, setBox_signup_stylep5] = useState({ display: 'none' });

  const [password_eye1, setPassword_eye1] = useState(false);
  const [password_eye2, setPassword_eye2] = useState(false);
  const [login_eye, setLogin_eye] = useState(false);

  const password_eye1_type = password_eye1
    ? { icon: 'fe-eye-off', type: 'text' }
    : { icon: 'fe-eye', type: 'password' };
  const password_eye2_type = password_eye2
    ? { icon: 'fe-eye-off', type: 'text' }
    : { icon: 'fe-eye', type: 'password' };
  const login_eye_type = login_eye ? 'text' : 'password';

  const [box_signup_progressline, setBox_signup_progressline] = useState({ width: '20%' });
  const signup_stepdetailArray = [
    '',
    'ข้อมูลบัญชีผู้ใช้',
    'ยืนยันเบอร์โทรศัพท์',
    'ยืนยัน OTP',
    'ข้อมูลร้านขายยา',
    'ประเภทใบอนุญาตและเอกสารสำคัญ',
  ];

  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const isAnyModalOpen = box_policy || box_forgot || box_signin || box_signup || box_signup_doc;
  useEffect(() => {
    if (isAnyModalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [isAnyModalOpen]);

  function showDialogCallback_General() {
    if (modal_popup.modaltype === 'modal-success') {
      setOtp_refcode('');
      setOtp_expire('');
      setOtp_phone_format('');
      setOtp_code_format('');

      setBox_signup_step(1);
      setBox_signin(false);
      setBox_signup(false);
      setBox_signup_doc(false);
    }

    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm() {
    signup_next();
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  useEffect(() => {
    const interval = setInterval(() => setBox_signup_time(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  function getOTPexpire() {
    var a = moment(box_signup_time);
    var b = moment(otp_expire);
    var diff = a.diff(b, 'seconds');
    var countback = 180 - diff;
    if (countback < 1) {
      return (
        <div className='text-center mt-2'>
          <p className='text-center text-red mt-2'>OTP ของคุณหมดอายุ กรุณาลองใหม่อีกครั้ง</p>
          <button
            type='button'
            className='btn btn-sm btn-warning'
            onClick={() => {
              get_smsotp();
            }}
          >
            ขอรหัส OTP อีกครั้ง
          </button>
        </div>
      );
    }
    return (
      <p className='text-center mt-2'>
        หมดอายุภายใน <span className='font-weight-bold text-primary'>{countback}</span> วินาที
      </p>
    );
  }

  const getRememberObject = () => {
    const localRem = getLocalToken('meya-rem');
    if (localRem && typeof localRem === 'object') {
      return localRem;
    }
    const remString = sessionStorage.getItem('meya-rem');
    if (remString && remString !== 'undefined' && remString !== null) {
      try {
        const userRem = JSON.parse(remString);
        return userRem;
      } catch (e) {}
    }
    return {
      rem: false,
      user: '',
      pass: '',
    };
  };

  const saveRemember = (userRem) => {
    if (userRem && userRem.rem === true) {
      setLocalToken('meya-rem', userRem);
      sessionStorage.removeItem('meya-rem');
    } else {
      removeLocalToken('meya-rem');
      sessionStorage.removeItem('meya-rem');
    }
  };

  const saveToken = (userToken, remember = false) => {
    if (remember) {
      setLocalToken('meya-token4', userToken);
      sessionStorage.removeItem('meya-token4');
    } else {
      sessionStorage.setItem('meya-token4', JSON.stringify(userToken));
      removeLocalToken('meya-token4');
    }
  };

  useEffect(() => {
    setRemember_me(getRememberObject());
    const existingToken = sessionStorage.getItem('meya-token4') || getLocalToken('meya-token4');
    if (!existingToken) {
      saveToken({
        shop_id: '-',
        shop_email: '-',
        shop_username: '-',
        shop_firstname: '-',
        shop_lastname: '-',
        shop_name: '-',
        shop_address: '-',
        shop_country: '-',
        shop_province: '-',
        shop_district: '-',
        shop_subdistrict: '-',
        shop_postcode: '-',
        shop_telno: '-',
        status: '-',
        token: '',
        logintime: '',
        role: 'guest',
        messages_chat_unread: 0,
      }, false);
    }
  }, []);

  function open_signin() {
    setPolicy_read(false);
    setOtp_refcode('');
    setOtp_expire('');
    setPhone_format('');
    setOtp_phone_format('');
    setOtp_code_format('');

    setBox_policy(false);
    setBox_forgot(false);
    setBox_signup(false);
    setBox_signin(true);
    setBox_signup_doc(false);
    setBox_signup_step(1);
    setBox_signup_docemail('');
    setPassword_eye1(false);
    setPassword_eye2(false);
  }

  function open_register() {
    setPolicy_read(false);
    setOtp_refcode('');
    setOtp_expire('');
    setPhone_format('');
    setOtp_phone_format('');
    setOtp_code_format('');

    setBox_signup_step(1);
    setBox_policy(false);
    setBox_forgot(false);
    setBox_signin(false);
    setBox_signup(true);
    setBox_signup_doc(false);
    setBox_signup_docemail('');

    setPassword_eye1(false);
    setPassword_eye2(false);
  }

  function open_forgot() {
    setPolicy_read(false);
    setOtp_refcode('');
    setOtp_expire('');
    setPhone_format('');
    setOtp_phone_format('');
    setOtp_code_format('');

    setBox_policy(false);
    setBox_signup(false);
    setBox_signin(false);
    setBox_forgot(true);
    setBox_signup_doc(false);
    setBox_signup_step(1);
    setBox_signup_docemail('');

    setPassword_eye1(false);
    setPassword_eye2(false);
  }

  useEffect(() => {
    if (props.popup_signin) {
      open_signin();
    }
  }, [props.popup_signin]);

  useEffect(() => {
    if (props.popup_register) {
      open_register();
    }
  }, [props.popup_register]);

  // Real-time verification helpers
  function handle_email_blur(e) {
    const email = e.target.value.trim();
    if (!email) {
      setEmail_status('invalid');
      setEmail_msg('กรุณากรอกอีเมล');
      return;
    }
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(email)) {
      setEmail_status('invalid');
      setEmail_msg('รูปแบบอีเมลไม่ถูกต้อง');
      return;
    }

    setEmail_status('checking');
    setEmail_msg('กำลังตรวจสอบอีเมล...');

    const formData = new FormData();
    formData.append('shop_email', email);
    checkEmailMutation.mutate(formData, {
      onSuccess: (data) => {
        if (data.status === 'OK') {
          setEmail_status('valid');
          setEmail_msg('อีเมลนี้สามารถใช้งานได้');
        } else if (data.status === 'Duplicate') {
          setEmail_status('duplicate');
          setEmail_msg('อีเมลนี้มีผู้ใช้งานแล้ว');
        } else {
          setEmail_status('invalid');
          setEmail_msg(data.message || 'เกิดข้อผิดพลาดในการตรวจสอบ');
        }
      },
      onError: () => {
        setEmail_status('invalid');
        setEmail_msg('ไม่สามารถตรวจสอบอีเมลได้ในขณะนี้');
      },
    });
  }

  function handle_password_change(val) {
    setSignup_password_val(val);
    const hasNumber = /\d/.test(val);
    const hasLowerCase = /[a-z]/.test(val);
    const hasUpperCase = /[A-Z]/.test(val);
    const isLongEnough = val.length >= 8;

    if (!val) {
      setPassword_status('invalid');
      setPassword_msg('กรุณากรอกรหัสผ่าน');
    } else if (!isLongEnough || !hasNumber || !hasLowerCase || !hasUpperCase) {
      setPassword_status('invalid');
      setPassword_msg('รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร, มีตัวพิมพ์ใหญ่, ตัวพิมพ์เล็ก และตัวเลข');
    } else {
      setPassword_status('valid');
      setPassword_msg('รหัสผ่านมีความปลอดภัย');
    }

    const confirmVal = document.getElementById('shop_confirmpassword')?.value || '';
    if (confirmVal) {
      if (val !== confirmVal) {
        setConfirm_status('invalid');
        setConfirm_msg('รหัสผ่านไม่ตรงกัน');
      } else {
        setConfirm_status('valid');
        setConfirm_msg('รหัสผ่านตรงกัน');
      }
    }
  }

  function handle_confirm_change(val) {
    const pwdVal = document.getElementById('shop_password')?.value || '';
    if (!val) {
      setConfirm_status('invalid');
      setConfirm_msg('กรุณายืนยันรหัสผ่าน');
    } else if (val !== pwdVal) {
      setConfirm_status('invalid');
      setConfirm_msg('รหัสผ่านไม่ตรงกัน');
    } else {
      setConfirm_status('valid');
      setConfirm_msg('รหัสผ่านตรงกัน');
    }
  }

  // Automatic Sign In
  function handle_auto_login(email, password) {
    const formData = new FormData();
    formData.append('signin_email', email);
    formData.append('signin_password', password);
    shopSigninMutation.mutate(formData, {
      onSuccess: (data) => {
        if (data.status === 'OK') {
          saveToken(data.userinfo);
          props.callback_signin(data.userinfo);
          setBox_signup(false);
          setBox_signin(false);
          setBox_forgot(false);
          setBox_signup_doc(false);
        } else {
          open_signin();
        }
      },
      onError: () => {
        open_signin();
      },
    });
  }

  // State-Deferred Submissions
  async function signup_submit_later() {
    setmodal_load({ enable: true, message: 'กำลังลงทะเบียนสมาชิก...' });
    await sleep(500);

    const formData = new FormData();
    formData.append('shop_firstname', document.getElementById('shop_firstname').value);
    formData.append('shop_lastname', document.getElementById('shop_lastname').value);
    formData.append('shop_email', document.getElementById('shop_email').value);
    formData.append('shop_username', document.getElementById('shop_username').value);
    formData.append('shop_password', document.getElementById('shop_password').value);

    const username = document.getElementById('shop_username').value;
    formData.append('shop_name', username);
    formData.append('shop_address', '-');
    formData.append('shop_province', '');
    formData.append('shop_district', '');
    formData.append('shop_subdistrict', '');
    formData.append('shop_postcode', '');

    var mobileotp = otp_phone_format.replace(/-/g, '');
    formData.append('shop_telno', mobileotp);
    formData.append('otp_telno', mobileotp);
    formData.append('refcode', otp_refcode);
    formData.append('otp', otp_code_format);

    submitAccountMutation
      .mutateAsync(formData)
      .then((data) => {
        setmodal_load({ enable: false, message: '' });
        if (data.status === 'OK') {
          const email = document.getElementById('shop_email').value;
          const password = document.getElementById('shop_password').value;

          setModal_popup({
            modaltype: 'modal-success',
            headers: 'ลงทะเบียนสำเร็จ',
            message: 'เจ้าหน้าที่จะติดต่อกลับเพื่อตรวจสอบข้อมูลภายหลัง',
            enable: true,
          });

          setTimeout(() => {
            handle_auto_login(email, password);
          }, 1500);
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: data.message,
            enable: true,
          });
        }
      })
      .catch((err) => {
        setmodal_load({ enable: false, message: '' });
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      });
  }

  async function signup_submit_full_flow() {
    if (!permit_type_selected) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'เตือน',
        message: 'กรุณาเลือกประเภทใบอนุญาต',
        enable: true,
      });
      return;
    }
    if (!docFiles.file1 || !docFiles.file2 || !docFiles.file3 || !docFiles.file4) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'เตือน',
        message: 'กรุณาอัปโหลดเอกสารสำคัญให้ครบทั้ง 4 รายการ',
        enable: true,
      });
      return;
    }

    setmodal_load({ enable: true, message: 'กำลังสร้างบัญชีผู้ใช้งาน...' });
    await sleep(500);

    const formData = new FormData();
    formData.append('shop_firstname', document.getElementById('shop_firstname').value);
    formData.append('shop_lastname', document.getElementById('shop_lastname').value);
    formData.append('shop_email', document.getElementById('shop_email').value);
    formData.append('shop_username', document.getElementById('shop_username').value);
    formData.append('shop_password', document.getElementById('shop_password').value);

    formData.append('shop_name', document.getElementById('shop_name').value);
    formData.append('shop_address', document.getElementById('shop_address').value);
    formData.append('shop_province', select_province);
    formData.append('shop_district', select_amphur);
    formData.append('shop_subdistrict', select_tambol);
    formData.append('shop_postcode', select_postcode);
    formData.append('shop_telno', document.getElementById('shop_telno').value);

    var mobileotp = otp_phone_format.replace(/-/g, '');
    formData.append('otp_telno', mobileotp);
    formData.append('refcode', otp_refcode);
    formData.append('otp', otp_code_format);

    submitAccountMutation
      .mutateAsync(formData)
      .then((data) => {
        if (data.status === 'OK') {
          const token = data.token;
          const signin_id = data.signin_id;
          const signin_email = data.signin_email;

          setmodal_load({ enable: true, message: 'กำลังอัปโหลดเอกสารสำคัญ...' });

          const docFormData = new FormData();
          docFormData.append('shop_email', signin_email);
          docFormData.append('shop_id', signin_id);
          docFormData.append('file1', docFiles.file1);
          docFormData.append('file2', docFiles.file2);
          docFormData.append('file3', docFiles.file3);
          docFormData.append('file4', docFiles.file4);

          axios
            .post(props.app_hostname + '/api/account/register/submitdocument', docFormData, {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                Authorization: 'Bearer ' + token,
              },
            })
            .then((docResponse) => {
              setmodal_load({ enable: false, message: '' });
              if (docResponse.data.status === 'OK') {
                setModal_popup({
                  modaltype: 'modal-success',
                  headers: 'สำเร็จ',
                  message: 'ลงทะเบียนและแนบเอกสารสำคัญสำเร็จเรียบร้อย!',
                  enable: true,
                });

                const email = document.getElementById('shop_email').value;
                const password = document.getElementById('shop_password').value;
                setTimeout(() => {
                  handle_auto_login(email, password);
                }, 1500);
              } else {
                setModal_popup({
                  modaltype: 'modal-warning',
                  headers: 'สร้างบัญชีสำเร็จ แต่การอัปโหลดเอกสารมีข้อผิดพลาด',
                  message: docResponse.data.message || 'โปรดอัปโหลดเอกสารอีกครั้งในระบบภายหลัง',
                  enable: true,
                });
                setBox_signup_docemail(signin_email);
                setBox_signup_docshopid(signin_id);
                setBox_signup_doctoken(token);

                const email = document.getElementById('shop_email').value;
                const password = document.getElementById('shop_password').value;
                setTimeout(() => {
                  handle_auto_login(email, password);
                }, 3000);
              }
            })
            .catch((docErr) => {
              setmodal_load({ enable: false, message: '' });
              setModal_popup({
                modaltype: 'modal-warning',
                headers: 'สร้างบัญชีสำเร็จ แต่ไม่สามารถอัปโหลดเอกสารได้',
                message: docErr.message || 'โปรดเข้าสู่ระบบและแนบเอกสารภายหลัง',
                enable: true,
              });
              const email = document.getElementById('shop_email').value;
              const password = document.getElementById('shop_password').value;
              setTimeout(() => {
                handle_auto_login(email, password);
              }, 3000);
            });
        } else {
          setmodal_load({ enable: false, message: '' });
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: data.message,
            enable: true,
          });
        }
      })
      .catch((err) => {
        setmodal_load({ enable: false, message: '' });
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      });
  }

  // Drag & Drop event handlers
  const handleFileChange = (fileKey, file) => {
    if (!file) return;
    setDocFiles((prev) => ({ ...prev, [fileKey]: file }));
    if (file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);
      setDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'image', url, name: file.name, size: file.size },
      }));
    } else if (file.type === 'application/pdf') {
      setDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'pdf', name: file.name, size: file.size },
      }));
    } else {
      setDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'file', name: file.name, size: file.size },
      }));
    }
  };

  const removeFile = (fileKey) => {
    setDocFiles((prev) => ({ ...prev, [fileKey]: null }));
    setDocPreviews((prev) => ({ ...prev, [fileKey]: null }));
  };

  const handleDrag = (fileKey, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive((prev) => ({ ...prev, [fileKey]: true }));
    } else if (e.type === 'dragleave') {
      setDragActive((prev) => ({ ...prev, [fileKey]: false }));
    }
  };

  const handleDrop = (fileKey, e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive((prev) => ({ ...prev, [fileKey]: false }));
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileChange(fileKey, e.dataTransfer.files[0]);
    }
  };

  function signup_next() {
    var formId = 'form-signup-p1';
    if (box_signup_step === 2) formId = 'form-signup-p3'; // phone
    if (box_signup_step === 4) formId = 'form-signup-p2'; // shop

    var forms = document.getElementById(formId);

    if (box_signup_step === 1) {
      const shop_firstname = document.getElementById('shop_firstname').value;
      const shop_lastname = document.getElementById('shop_lastname').value;
      const shop_username = document.getElementById('shop_username').value;

      if (!shop_firstname || shop_firstname.length < 2) {
        document.getElementById('shop_firstname').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_firstname').setCustomValidity('');
      }

      if (!shop_lastname || shop_lastname.length < 2) {
        document.getElementById('shop_lastname').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_lastname').setCustomValidity('');
      }

      if (!shop_username || shop_username.length < 2) {
        document.getElementById('shop_username').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_username').setCustomValidity('');
      }

      if (email_status !== 'valid') {
        document.getElementById('shop_email').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_email').setCustomValidity('');
      }

      if (password_status !== 'valid') {
        document.getElementById('shop_password').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_password').setCustomValidity('');
      }

      if (confirm_status !== 'valid') {
        document.getElementById('shop_confirmpassword').setCustomValidity('invalid');
      } else {
        document.getElementById('shop_confirmpassword').setCustomValidity('');
      }

      if (!policy_read) {
        document.getElementById('agreeterm').setCustomValidity('invalid');
      } else {
        document.getElementById('agreeterm').setCustomValidity('');
      }
    }

    if (forms.checkValidity() === false) {
      forms.classList.add('was-validated');
    } else {
      forms.classList.remove('was-validated');
      if (box_signup_step === 2) {
        setOtp_refcode('');
        setOtp_code_format('');
        if (otp_phone_format !== '') {
          get_smsotp();
        }
      }
      setBox_signup_step(box_signup_step + 1);
    }
  }

  function signup_previous() {
    setBox_signup_step(box_signup_step - 1);
  }

  useEffect(() => {
    if (box_signup_step > 1) {
      setBox_signup_previous(true);
    } else {
      setBox_signup_previous(false);
    }

    if (box_signup_step === 1 || box_signup_step === 2 || box_signup_step === 4) {
      setBox_signup_next(true);
      setBox_signup_submit(false);
    } else {
      setBox_signup_next(false);
      setBox_signup_submit(true);
    }

    if (box_signup_step === 1) {
      setBox_signup_haveaccount(true);
    } else {
      setBox_signup_haveaccount(false);
    }

    if (box_signup_step === 1) {
      setBox_signup_stylep1({ display: 'block' });
      setBox_signup_stylep2({ display: 'none' });
      setBox_signup_stylep3({ display: 'none' });
      setBox_signup_stylep4({ display: 'none' });
      setBox_signup_stylep5({ display: 'none' });
      setBox_signup_progressline({ width: '20%' });
    } else if (box_signup_step === 2) {
      setBox_signup_stylep1({ display: 'none' });
      setBox_signup_stylep2({ display: 'none' });
      setBox_signup_stylep3({ display: 'block' });
      setBox_signup_stylep4({ display: 'none' });
      setBox_signup_stylep5({ display: 'none' });
      setBox_signup_progressline({ width: '40%' });
    } else if (box_signup_step === 3) {
      setBox_signup_stylep1({ display: 'none' });
      setBox_signup_stylep2({ display: 'none' });
      setBox_signup_stylep3({ display: 'none' });
      setBox_signup_stylep4({ display: 'block' });
      setBox_signup_stylep5({ display: 'none' });
      setBox_signup_progressline({ width: '60%' });
    } else if (box_signup_step === 4) {
      setBox_signup_stylep1({ display: 'none' });
      setBox_signup_stylep2({ display: 'block' });
      setBox_signup_stylep3({ display: 'none' });
      setBox_signup_stylep4({ display: 'none' });
      setBox_signup_stylep5({ display: 'none' });
      setBox_signup_progressline({ width: '80%' });
    } else if (box_signup_step === 5) {
      setBox_signup_stylep1({ display: 'none' });
      setBox_signup_stylep2({ display: 'none' });
      setBox_signup_stylep3({ display: 'none' });
      setBox_signup_stylep4({ display: 'none' });
      setBox_signup_stylep5({ display: 'block' });
      setBox_signup_progressline({ width: '100%' });
    }

    var formId = 'form-signup-p1';
    if (box_signup_step === 2) formId = 'form-signup-p3';
    if (box_signup_step === 3) formId = 'form-signup-p4';
    if (box_signup_step === 4) formId = 'form-signup-p2';
    if (box_signup_step === 5) formId = 'form-signup-p5';

    var forms = document.getElementById(formId);
    if (forms !== null) {
      forms.classList.remove('was-validated');
    }

    setPassword_eye1(false);
    setPassword_eye2(false);
  }, [box_signup_step]);

  function check_emailduplicate_holdstep() {
    const formData = new FormData();
    formData.append('shop_email', document.getElementById('shop_email').value);

    checkEmailMutation.mutate(formData, {
      onSuccess: (data) => {
        if (data.status === 'OK') {
          var shop_email = document.getElementById('shop_email');
          shop_email.setCustomValidity('');
        } else if (data.status === 'Duplicate') {
          var forms = document.getElementById('form-signup-p1');
          forms.classList.remove('was-validated');
          var shop_email = document.getElementById('shop_email');
          shop_email.setCustomValidity('อีเมลนี้มีผู้ใช้งานแล้ว');
          forms.classList.add('was-validated');
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: data.message,
            enable: true,
          });
        }
      },
      onError: (err) => {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      },
    });
  }

  function check_emailduplicate() {
    const formData = new FormData();
    formData.append('shop_email', document.getElementById('shop_email').value);

    checkEmailMutation.mutate(formData, {
      onSuccess: (data) => {
        if (data.status === 'OK') {
          var shop_email = document.getElementById('shop_email');
          shop_email.setCustomValidity('');
          var forms = document.getElementById('form-signup-p1');
          forms.classList.remove('was-validated');
          setBox_signup_step(box_signup_step + 1);
        } else if (data.status === 'Duplicate') {
          var forms = document.getElementById('form-signup-p1');
          forms.classList.remove('was-validated');
          var shop_email = document.getElementById('shop_email');
          shop_email.setCustomValidity('อีเมลนี้มีผู้ใช้งานแล้ว');
          forms.classList.add('was-validated');
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: data.message,
            enable: true,
          });
        }
      },
      onError: (err) => {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      },
    });
  }

  function get_smsotp() {
    setOtp_refcode('');
    var mobileotp = otp_phone_format.replace(/-/g, '');
    const formData = new FormData();
    formData.append('otp_telno', mobileotp);

    axios
      .post(props.app_hostname + '/api/account/register/otprequest', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
          Authorization: 'Basic ' + btoa('Hvqhzd3f_zAXSsK7x2QfslGn0EvBoj'),
        },
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          setOtp_refcode(response.data.data.refcode);
          setOtp_expire(new Date());
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: response.data.message,
            enable: true,
          });
          setOtp_refcode('');
        }
      })
      .catch((err) => {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
        setOtp_refcode('');
      });
  }

  async function signup_submit() {
    if (box_signup_step === 3) {
      var forms = document.getElementById('form-signup-p4');
      if (forms.checkValidity() === false) {
        forms.classList.add('was-validated');
      } else {
        forms.classList.remove('was-validated');
        setShowSuccessOptionModal(true);
      }
    } else if (box_signup_step === 5) {
      signup_submit_full_flow();
    }
  }

  async function signup_submit_doc() {
    var forms = document.getElementById('form-submitdoc');
    if (forms.checkValidity() === false) {
      forms.classList.add('was-validated');
    } else {
      setmodal_load({ enable: true, message: 'กำลังอัพโหลดเอกสารสำคัญ' });
      await sleep(500);

      forms.classList.remove('was-validated');

      const formData = new FormData();
      formData.append('shop_email', box_signup_docemail);
      formData.append('shop_id', box_signup_docshopid);

      formData.append('file1', document.getElementById('customFile1-resumit').files[0]);
      formData.append('file2', document.getElementById('customFile2-resumit').files[0]);
      formData.append('file3', document.getElementById('customFile3-resumit').files[0]);
      formData.append('file4', document.getElementById('customFile4-resumit').files[0]);

      axios
        .post(props.app_hostname + '/api/account/register/submitdocument', formData, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data;',
            Authorization: 'Bearer ' + box_signup_doctoken,
          },
        })
        .then((response) => {
          setmodal_load({ enable: false, message: '' });
          if (response.data.status === 'OK') {
            setBox_signup_doc(false);
            setModal_popup({
              modaltype: 'modal-success',
              headers: 'สำเร็จ',
              message: response.data.message,
              enable: true,
            });
          } else {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: response.data.message,
              enable: true,
            });
          }
        })
        .catch((err) => {
          setmodal_load({ enable: false, message: '' });
          setModal_popup({
            modaltype: 'modal-error',
            headers: 'ผิดพลาด',
            message: err.message,
            enable: true,
          });
        });
    }
  }

  async function handle_forgot() {
    document.getElementById('fotgot_email').setCustomValidity('');
    var formelement = document.getElementById('forgotpanel');
    formelement.classList.remove('was-validated');
    if (formelement.checkValidity() === false) {
      document.getElementById('email-forgot-feedback').innerText =
        'กรุณากรอกอีเมลที่ท่านได้สมัครไว้';
      formelement.classList.add('was-validated');
    } else {
      setmodal_load({ enable: true, message: 'ระบบกำลังส่งลิ้งค์ไปยังอีเมล' });
      await sleep(500);

      const formData = new FormData(formelement);
      axios
        .post(props.app_hostname + '/api/account/auth/passrequest', formData, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data;',
            Authorization: 'Basic ' + btoa('Hvqhzd3f_zAXSsK7x2QfslGn0EvBoj'),
          },
        })
        .then((response) => {
          setmodal_load({ enable: false, message: '' });
          if (response.data.status === 'OK') {
            setBox_forgot(false);
            setModal_popup({
              modaltype: 'modal-success',
              headers: 'สำเร็จ',
              message: response.data.message,
              enable: true,
            });
          } else {
            var formelement1 = document.getElementById('forgotpanel');
            formelement1.classList.remove('was-validated');
            document.getElementById('fotgot_email').setCustomValidity('x');
            document.getElementById('email-forgot-feedback').innerText = response.data.message;
            formelement1.classList.add('was-validated');
          }
        })
        .catch((err) => {
          setmodal_load({ enable: false, message: '' });
          setModal_popup({
            modaltype: 'modal-error',
            headers: 'ผิดพลาด',
            message: err.message,
            enable: true,
          });
        });
    }
  }

  function handle_login() {
    var formelement = document.getElementById('accesspanel');
    if (formelement.checkValidity() === false) {
      formelement.classList.add('was-validated');
    } else {
      const formData = new FormData(formelement);
      shopSigninMutation.mutate(formData, {
        onSuccess: (data) => {
          if (data.status === 'OK') {
            const isRemember = remember_me.rem === true;
            if (isRemember) {
              saveRemember(remember_me);
            } else {
              saveRemember({
                rem: false,
                user: '',
                pass: '',
              });
            }
            saveToken(data.userinfo, isRemember);
            if (props.callback_signin) {
              props.callback_signin(data.userinfo, isRemember);
            }
          } else {
            saveToken({
              shop_id: '-',
              shop_email: '-',
              shop_username: '-',
              shop_firstname: '-',
              shop_lastname: '-',
              shop_name: '-',
              shop_address: '-',
              shop_country: '-',
              shop_province: '-',
              shop_district: '-',
              shop_subdistrict: '-',
              shop_postcode: '-',
              shop_telno: '-',
              status: '-',
              token: '',
              logintime: '',
              role: 'guest',
              messages_chat_unread: 0,
            });

            if (data.userstatus === 'pending' && data.shopdocument === 'pending') {
              setBox_signup_docemail(data.signin_email);
              setBox_signup_docshopid(data.signin_id);
              setBox_signup_doctoken(data.token);
              setPendingUserInfo(data.userinfo);

              setPendingModalMode('warning');
              setWizardStep(1);
              setShowLoginPendingModal(true);

              setPolicy_read(false);
              setOtp_refcode('');
              setOtp_expire('');
              setPhone_format('');
              setOtp_phone_format('');
              setOtp_code_format('');

              setBox_policy(false);
              setBox_forgot(false);
              setBox_signup(false);
              setBox_signin(false);
              setBox_signup_step(1);
            } else {
              setModal_popup({
                modaltype: 'modal-warning',
                headers: 'ขออภัย',
                message: data.message,
                enable: true,
              });
            }
          }
        },
        onError: (err) => {
          setBox_signup_docemail('');
          setModal_popup({
            modaltype: 'modal-error',
            headers: 'ผิดพลาด',
            message: err.message,
            enable: true,
          });
        },
      });
    }
  }

  // Sequential auto-populate and address-fetching synchronization for Login Completion Wizard
  useEffect(() => {
    if (pendingUserInfo) {
      const hasShopName = pendingUserInfo.shop_name && pendingUserInfo.shop_name !== '-';
      if (hasShopName) {
        if (pendingUserInfo.shop_name && wizard_shop_name === '') {
          setWizard_shop_name(pendingUserInfo.shop_name);
        }
        if (
          pendingUserInfo.shop_address &&
          wizard_shop_address === '' &&
          pendingUserInfo.shop_address !== '-'
        ) {
          setWizard_shop_address(pendingUserInfo.shop_address);
        }
        if (pendingUserInfo.shop_telno && wizard_shop_telno === '') {
          fillwizard_phone(pendingUserInfo.shop_telno);
        }
        if (pendingUserInfo.shop_province && wizard_select_province === '') {
          setWizard_select_province(pendingUserInfo.shop_province);
        }
      }
    }
  }, [pendingUserInfo]);

  // Sequential address restorer for wizard: Amphur
  useEffect(() => {
    if (pendingUserInfo && pendingUserInfo.shop_district && wizard_list_amphur.length > 0) {
      if (wizard_select_province === pendingUserInfo.shop_province) {
        if (wizard_list_amphur.includes(pendingUserInfo.shop_district)) {
          if (wizard_select_amphur !== pendingUserInfo.shop_district) {
            setWizard_select_amphur(pendingUserInfo.shop_district);
          }
        }
      }
    }
  }, [wizard_list_amphur, pendingUserInfo, wizard_select_province]);

  // Sequential address restorer for wizard: Tambol & Postcode
  useEffect(() => {
    if (pendingUserInfo && pendingUserInfo.shop_subdistrict && wizard_list_tambol.length > 0) {
      if (wizard_select_amphur === pendingUserInfo.shop_district) {
        const matchedTambol = wizard_list_tambol.find(
          (t) => t.name_th === pendingUserInfo.shop_subdistrict,
        );
        if (matchedTambol) {
          if (wizard_select_tambol !== pendingUserInfo.shop_subdistrict) {
            setWizard_select_tambol(pendingUserInfo.shop_subdistrict);
          }
          if (
            pendingUserInfo.shop_postcode &&
            wizard_select_postcode !== pendingUserInfo.shop_postcode
          ) {
            setWizard_select_postcode(pendingUserInfo.shop_postcode);
          }
        }
      }
    }
  }, [wizard_list_tambol, pendingUserInfo, wizard_select_amphur]);

  // Drag & Drop / Form helper functions for Login Completion Wizard
  const handleWizardFileChange = (fileKey, file) => {
    if (!file) return;
    setWizardDocFiles((prev) => ({ ...prev, [fileKey]: file }));
    if (file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);
      setWizardDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'image', url, name: file.name, size: file.size },
      }));
    } else if (file.type === 'application/pdf') {
      setWizardDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'pdf', name: file.name, size: file.size },
      }));
    } else {
      setWizardDocPreviews((prev) => ({
        ...prev,
        [fileKey]: { type: 'file', name: file.name, size: file.size },
      }));
    }
  };

  const removeWizardFile = (fileKey) => {
    setWizardDocFiles((prev) => ({ ...prev, [fileKey]: null }));
    setWizardDocPreviews((prev) => ({ ...prev, [fileKey]: null }));
  };

  const handleWizardDrag = (fileKey, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setWizardDragActive((prev) => ({ ...prev, [fileKey]: true }));
    } else if (e.type === 'dragleave') {
      setWizardDragActive((prev) => ({ ...prev, [fileKey]: false }));
    }
  };

  const handleWizardDrop = (fileKey, e) => {
    e.preventDefault();
    e.stopPropagation();
    setWizardDragActive((prev) => ({ ...prev, [fileKey]: false }));
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleWizardFileChange(fileKey, e.dataTransfer.files[0]);
    }
  };

  const fillwizard_phone = (input) => {
    const numbers = input.replace(/[^0-9]/g, '').toString();
    const pat = [];
    if (numbers.length > 0) pat.push(numbers.substring(0, 3));
    if (numbers.length >= 4) pat.push(numbers.substring(3, 6));
    if (numbers.length >= 7) pat.push(numbers.substring(6, 10));
    setWizard_phone_format(pat.length > 0 ? pat.join('-') : '');
    setWizard_shop_telno(numbers);
  };

  async function submit_wizard_profile() {
    if (!wizard_permit_type_selected) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'เตือน',
        message: 'กรุณาเลือกประเภทใบอนุญาต',
        enable: true,
      });
      return;
    }
    if (
      !wizardDocFiles.file1 ||
      !wizardDocFiles.file2 ||
      !wizardDocFiles.file3 ||
      !wizardDocFiles.file4
    ) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'เตือน',
        message: 'กรุณาอัปโหลดเอกสารสำคัญให้ครบทั้ง 4 รายการ',
        enable: true,
      });
      return;
    }

    setmodal_load({ enable: true, message: 'กำลังอัปโหลดเอกสารและบันทึกข้อมูล...' });
    await sleep(500);

    const editFormData = new FormData();
    editFormData.append('shop_id', box_signup_docshopid);
    editFormData.append('shop_name', wizard_shop_name);
    editFormData.append('shop_address', wizard_shop_address);
    editFormData.append('shop_province', wizard_select_province);
    editFormData.append('shop_district', wizard_select_amphur);
    editFormData.append('shop_subdistrict', wizard_select_tambol);
    editFormData.append('shop_postcode', wizard_select_postcode);
    editFormData.append('shop_telno', wizard_shop_telno);

    if (pendingUserInfo) {
      editFormData.append('status', pendingUserInfo.status || 'pending');
      editFormData.append('bank_name', pendingUserInfo.bank_name || '');
      editFormData.append('bank_acc_name', pendingUserInfo.bank_acc_name || '');
      editFormData.append('bank_acc_id', pendingUserInfo.bank_acc_id || '');
      editFormData.append('shopdocument', pendingUserInfo.shopdocument || '');
      editFormData.append('shop_firstname', pendingUserInfo.shop_firstname || '');
      editFormData.append('shop_lastname', pendingUserInfo.shop_lastname || '');
      editFormData.append('shop_email', pendingUserInfo.shop_email || box_signup_docemail);
      editFormData.append('shop_username', pendingUserInfo.shop_username || '');
      editFormData.append('user_type', pendingUserInfo.user_type || '');
    } else {
      editFormData.append('status', 'pending');
      editFormData.append('shop_email', box_signup_docemail);
    }

    axios
      .post(props.app_hostname + '/api/account/shop/edit', editFormData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
          Authorization: 'Bearer ' + box_signup_doctoken,
        },
      })
      .then((editResponse) => {
        if (editResponse.data.status !== 'OK') {
          throw new Error(editResponse.data.message || 'บันทึกข้อมูลร้านค้าล้มเหลว');
        }

        const docFormData = new FormData();
        docFormData.append('shop_email', box_signup_docemail);
        docFormData.append('shop_id', box_signup_docshopid);
        docFormData.append('shop_name', wizard_shop_name);
        docFormData.append('shop_address', wizard_shop_address);
        docFormData.append('shop_province', wizard_select_province);
        docFormData.append('shop_district', wizard_select_amphur);
        docFormData.append('shop_subdistrict', wizard_select_tambol);
        docFormData.append('shop_postcode', wizard_select_postcode);
        docFormData.append('shop_telno', wizard_shop_telno);

        // Documents
        docFormData.append('file1', wizardDocFiles.file1);
        docFormData.append('file2', wizardDocFiles.file2);
        docFormData.append('file3', wizardDocFiles.file3);
        docFormData.append('file4', wizardDocFiles.file4);

        return axios.post(
          props.app_hostname + '/api/account/register/submitdocument',
          docFormData,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data;',
              Authorization: 'Bearer ' + box_signup_doctoken,
            },
          },
        );
      })
      .then((docResponse) => {
        setmodal_load({ enable: false, message: '' });
        if (docResponse.data.status === 'OK') {
          setModal_popup({
            modaltype: 'modal-success',
            headers: 'สำเร็จ',
            message: 'อัปโหลดเอกสารและเปิดใช้งานร้านค้าสำเร็จแล้ว!',
            enable: true,
          });

          const updatedUserInfo = {
            ...(pendingUserInfo || {}),
            shop_id: box_signup_docshopid,
            shop_email: box_signup_docemail,
            status: 'pending',
            token: box_signup_doctoken,
            role: 'guest',
            shop_name: wizard_shop_name,
            shop_address: wizard_shop_address,
            shop_province: wizard_select_province,
            shop_district: wizard_select_amphur,
            shop_subdistrict: wizard_select_tambol,
            shop_postcode: wizard_select_postcode,
            shop_telno: wizard_shop_telno,
          };

          setTimeout(() => {
            saveToken(updatedUserInfo);
            props.callback_signin(updatedUserInfo);
            setShowLoginPendingModal(false);
            setPendingUserInfo(null);
          }, 1500);
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: docResponse.data.message,
            enable: true,
          });
        }
      })
      .catch((err) => {
        setmodal_load({ enable: false, message: '' });
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      });
  }

  // Shared formatter for both shop phone and OTP phone fields
  function formatPhone(input, setter) {
    if (!input) {
      setter('');
      return;
    }
    const raw = String(input);
    const thaiDigits = { '๐':'0', '๑':'1', '๒':'2', '๓':'3', '๔':'4', '๕':'5', '๖':'6', '๗':'7', '๘':'8', '๙':'9' };
    const kedmanee = { 'จ':'0', 'ๅ':'1', '/':'2', 'ภ':'4', 'ถ':'5', 'ุ':'6', 'ึ':'7', 'ค':'8', 'ต':'9' };
    const hasKedmanee = Array.from(raw).some((ch) => Boolean(kedmanee[ch]));

    let res = '';
    for (let i = 0; i < raw.length; i++) {
      const c = raw[i];
      if (thaiDigits[c] !== undefined) {
        res += thaiDigits[c];
      } else if (kedmanee[c] !== undefined) {
        res += kedmanee[c];
      } else if (c === '-' && hasKedmanee) {
        res += '3';
      } else if (/[0-9]/.test(c)) {
        res += c;
      }
    }
    if (res.startsWith('66') && res.length > 10) {
      res = '0' + res.slice(2);
    }
    const numbers = res.slice(0, 10);
    const pat = [];
    if (numbers.length > 0) pat.push(numbers.substring(0, 3));
    if (numbers.length >= 4) pat.push(numbers.substring(3, 6));
    if (numbers.length >= 7) pat.push(numbers.substring(6, 10));
    setter(pat.length > 0 ? pat.join('-') : '');
  }

  const fillphone = (input) => formatPhone(input, setPhone_format);
  const fillotp_phone = (input) => formatPhone(input, setOtp_phone_format);

  function fillotp_code(input) {
    if (!input) {
      setOtp_code_format('');
      return;
    }
    const raw = String(input);
    const thaiDigits = { '๐':'0', '๑':'1', '๒':'2', '๓':'3', '๔':'4', '๕':'5', '๖':'6', '๗':'7', '๘':'8', '๙':'9' };
    const kedmanee = { 'จ':'0', 'ๅ':'1', '/':'2', 'ภ':'4', 'ถ':'5', 'ุ':'6', 'ึ':'7', 'ค':'8', 'ต':'9' };
    const hasKedmanee = Array.from(raw).some((ch) => Boolean(kedmanee[ch]));
    let res = '';
    for (let i = 0; i < raw.length; i++) {
      const c = raw[i];
      if (thaiDigits[c] !== undefined) {
        res += thaiDigits[c];
      } else if (kedmanee[c] !== undefined) {
        res += kedmanee[c];
      } else if (c === '-' && hasKedmanee) {
        res += '3';
      } else if (/[0-9]/.test(c)) {
        res += c;
      }
    }
    setOtp_code_format(res.substring(0, 6));
  }

  function handlechange_login(id, val) {
    if (id === 'user') {
      setRemember_me((prevState) => ({
        ...prevState,
        user: val,
      }));
    } else if (id === 'pass') {
      setRemember_me((prevState) => ({
        ...prevState,
        pass: val,
      }));
    } else if (id === 'rem') {
      setRemember_me((prevState) => ({
        ...prevState,
        rem: val,
      }));
    }
  }

  return (
    <>
      <style>{`
        /* Hide the helper hint when the form was validated and the password input is invalid. 
           Uses :has() which is supported in modern browsers (Chrome, Safari, Edge). 
           If :has() is not available the invalid-feedback will still show, but the hint may remain.
        */
        .signup-page.was-validated .form-group:has(.inp-password:invalid) .password-hint {
          display: none !important;
        }
      `}</style>
      {isAnyModalOpen && (
        <div
          onClick={() => {
            setBox_signup(false);
            setBox_signin(false);
            setBox_forgot(false);
          }}
          className='modal-overlay'
        ></div>
      )}

      <div id='area-signin'>
        {box_signup === true ? (
          <div className='box-signup'>
            <div className='box-signup-header'>
              <div
                className='closeicon'
                onClick={() => {
                  setBox_signup(false);
                }}
              >
                <i className='mdi mdi-window-close'></i>
              </div>
              <h6 className='text-center'>ลงทะเบียน</h6>
              <p className='text-center'>ลงทะเบียนเพื่อเริ่มใช้งานบริการของ มียา.com</p>
              <div className='d-block mb-2'>
                <div className='progressbar-wrapper d-none d-md-block mb-2'>
                  <div className='f1-steps'>
                    <div className='f1-progress' id='signup-step'>
                      <div
                        className='f1-progress-line'
                        data-now-value='10'
                        data-number-of-steps='5'
                        style={box_signup_progressline}
                      ></div>
                    </div>
                    <div
                      className={'f1-step ' + `${box_signup_step === 1 && 'active'}`}
                      id='f1-step1'
                    >
                      <p>ข้อมูลบัญชีผู้ใช้</p>
                      <div className='f1-step-icon'>
                        <i className='far fa-user'></i>
                      </div>
                    </div>
                    <div
                      className={'f1-step ' + `${box_signup_step === 2 && 'active'}`}
                      id='f1-step2'
                    >
                      <p>ยืนยันเบอร์โทรศัพท์</p>
                      <div className='f1-step-icon'>
                        <i className='fas fa-mobile-alt'></i>
                      </div>
                    </div>
                    <div
                      className={'f1-step ' + `${box_signup_step === 3 && 'active'}`}
                      id='f1-step3'
                    >
                      <p>ยืนยัน OTP</p>
                      <div className='f1-step-icon'>
                        <i className='fa fa-key'></i>
                      </div>
                    </div>
                    <div
                      className={'f1-step ' + `${box_signup_step === 4 && 'active'}`}
                      id='f1-step4'
                    >
                      <p>ข้อมูลร้านขายยา</p>
                      <div className='f1-step-icon'>
                        <i className='fas fa-store'></i>
                      </div>
                    </div>
                    <div
                      className={'f1-step ' + `${box_signup_step === 5 && 'active'}`}
                      id='f1-step5'
                    >
                      <p>เอกสารสำคัญ</p>
                      <div className='f1-step-icon'>
                        <i className='far fa-file-alt'></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-block'>
                  <h5 className='font-size-18 text-dark font-th'>
                    ขั้นตอนที่ {box_signup_step} : {signup_stepdetailArray[box_signup_step]}
                  </h5>
                </div>
              </div>
            </div>
            <div className='box-signup-content'>
              <form
                onSubmit={(e) => e.preventDefault()}
                id='form-signup-p1'
                className='signup-page mt-2'
                style={box_signup_stylep1}
              >
                <div className='row'>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_firstname'>ชื่อ</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_firstname'
                        name='shop_firstname'
                        placeholder='กรอกชื่อ'
                        autoComplete='new-off'
                        minLength='2'
                        required
                      />
                      <div className='invalid-feedback'>อย่างน้อย 2 ตัวอักษร</div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_lastname'>นามสกุล</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_lastname'
                        name='shop_lastname'
                        placeholder='กรอกนามสกุล'
                        autoComplete='new-off'
                        minLength='2'
                        required
                      />
                      <div className='invalid-feedback'>อย่างน้อย 2 ตัวอักษร</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_email'>อีเมล</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_email'
                        name='shop_email'
                        autoComplete='new-off'
                        placeholder='กรอกอีเมล'
                        required
                        onBlur={handle_email_blur}
                        onChange={() => {
                          if (email_status !== 'idle') {
                            setEmail_status('idle');
                            setEmail_msg('');
                          }
                        }}
                      />
                      {email_status !== 'idle' && (
                        <div className={`realtime-validation-msg ${email_status}`}>
                          {email_status === 'checking' && (
                            <i className='fas fa-spinner fa-spin mr-1'></i>
                          )}
                          {email_status === 'valid' && <i className='fas fa-check-circle mr-1'></i>}
                          {(email_status === 'duplicate' || email_status === 'invalid') && (
                            <i className='fas fa-times-circle mr-1'></i>
                          )}
                          {email_msg}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_username'>ชื่อร้าน หรือ Username</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_username'
                        name='shop_username'
                        autoComplete='new-off'
                        placeholder='กรอกชื่อร้าน หรือ Username'
                        minLength='2'
                        required
                      />
                      <div className='invalid-feedback'>อย่างน้อย 2 ตัวอักษร</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_password'>รหัสผ่าน</label>
                      <div className='input-group mb-1 font-th'>
                        <input
                          type={password_eye1_type.type}
                          className='form-control inp-password text-dark'
                          id='shop_password'
                          name='shop_password'
                          autoComplete='new-off'
                          placeholder='กรอกรหัสผ่าน'
                          required
                          onChange={(e) => handle_password_change(e.target.value)}
                        />
                        <div className='d-flex'>
                          <span
                            className='btn password-toggle-icon'
                            onClick={() => setPassword_eye1(!password_eye1)}
                          >
                            <i className={password_eye1_type.icon}></i>
                          </span>
                        </div>
                      </div>
                      <div
                        className='password-checklist-wrapper mt-2 font-th'
                        style={{
                          fontSize: '0.76rem',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '6px',
                          padding: '4px 0 0 2px',
                          background: 'none',
                          border: 'none',
                          textAlign: 'left',
                        }}
                      >
                        <div
                          style={{
                            color: signup_password_val.length >= 8 ? '#10b981' : '#64748b',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'color 0.2s',
                          }}
                        >
                          <i
                            className={
                              signup_password_val.length >= 8
                                ? 'fas fa-check text-success'
                                : 'fas fa-times'
                            }
                            style={{
                              fontSize: '0.8rem',
                              color: signup_password_val.length >= 8 ? '#10b981' : '#94a3b8',
                              width: '14px',
                              marginRight: '6px',
                            }}
                          ></i>
                          <span>มีความยาวอย่างน้อย 8 ตัวอักษร</span>
                        </div>
                        <div
                          style={{
                            color: /[A-Z]/.test(signup_password_val) ? '#10b981' : '#64748b',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'color 0.2s',
                          }}
                        >
                          <i
                            className={
                              /[A-Z]/.test(signup_password_val)
                                ? 'fas fa-check text-success'
                                : 'fas fa-times'
                            }
                            style={{
                              fontSize: '0.8rem',
                              color: /[A-Z]/.test(signup_password_val) ? '#10b981' : '#94a3b8',
                              width: '14px',
                              marginRight: '6px',
                            }}
                          ></i>
                          <span>มีตัวพิมพ์ใหญ่ (A-Z)</span>
                        </div>
                        <div
                          style={{
                            color: /[a-z]/.test(signup_password_val) ? '#10b981' : '#64748b',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'color 0.2s',
                          }}
                        >
                          <i
                            className={
                              /[a-z]/.test(signup_password_val)
                                ? 'fas fa-check text-success'
                                : 'fas fa-times'
                            }
                            style={{
                              fontSize: '0.8rem',
                              color: /[a-z]/.test(signup_password_val) ? '#10b981' : '#94a3b8',
                              width: '14px',
                              marginRight: '6px',
                            }}
                          ></i>
                          <span>มีตัวพิมพ์เล็ก (a-z)</span>
                        </div>
                        <div
                          style={{
                            color: /\d/.test(signup_password_val) ? '#10b981' : '#64748b',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'color 0.2s',
                          }}
                        >
                          <i
                            className={
                              /\d/.test(signup_password_val)
                                ? 'fas fa-check text-success'
                                : 'fas fa-times'
                            }
                            style={{
                              fontSize: '0.8rem',
                              color: /\d/.test(signup_password_val) ? '#10b981' : '#94a3b8',
                              width: '14px',
                              marginRight: '6px',
                            }}
                          ></i>
                          <span>มีตัวเลข (0-9)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_confirmpassword'>ยืนยันรหัสผ่าน</label>
                      <div className='input-group mb-3 font-th'>
                        <input
                          type={password_eye2_type.type}
                          className='form-control text-dark'
                          id='shop_confirmpassword'
                          name='shop_confirmpassword'
                          autoComplete='new-off'
                          placeholder='กรอกรหัสผ่านอีกครั้ง'
                          required
                          onChange={(e) => handle_confirm_change(e.target.value)}
                        />
                        <div className='d-flex'>
                          <span
                            className='btn password-toggle-icon'
                            onClick={() => setPassword_eye2(!password_eye2)}
                          >
                            <i className={password_eye2_type.icon}></i>
                          </span>
                        </div>
                      </div>
                      {confirm_status !== 'idle' && (
                        <div className={`realtime-validation-msg ${confirm_status}`}>
                          {confirm_status === 'valid' ? (
                            <>
                              <i className='fas fa-check-circle mr-1'></i> {confirm_msg}
                            </>
                          ) : (
                            <>
                              <i className='fas fa-times-circle mr-1'></i> {confirm_msg}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='agreeterm font-th'>
                  <div
                    className='form-check'
                    onClick={() => {
                      setBox_policy(true);
                    }}
                  >
                    <input
                      type='checkbox'
                      className='form-check-input'
                      id='agreeterm'
                      name='agreeterm'
                      checked={policy_read}
                      required
                    />
                    <label className='font-th mb-0' htmlFor='agreeterm'>
                      ฉันยอมรับ <span>เงื่อนไขการใช้บริการ</span>
                    </label>
                    <div className='invalid-feedback mt-0'>กรุณายอมรับเงื่อนไขการใช้บริการ</div>
                  </div>
                </div>
              </form>

              <form
                onSubmit={(e) => e.preventDefault()}
                id='form-signup-p2'
                className='signup-page'
                style={box_signup_stylep2}
                encType='multipart/form-data'
              >
                <div className='row'>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_name'>ชื่อร้าน หรือ Username</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_name'
                        name='shop_name'
                        placeholder='กรอกชื่อร้าน หรือ Username'
                        autoComplete='new-off'
                        minLength='5'
                        required
                      />
                      <div className='invalid-feedback'>อย่างน้อย 5 ตัวอักษร</div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6'>
                    <div className='form-group'>
                      <label htmlFor='shop_address'>ที่อยู่</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_address'
                        name='shop_address'
                        placeholder='กรอกที่อยู่'
                        autoComplete='new-off'
                        required
                      />
                      <div className='invalid-feedback'>กรุณากรอกที่อยู่ร้าน</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12 col-sm-4'>
                    <div className='form-group'>
                      <label htmlFor='shop_province'>จังหวัด</label>
                      <select
                        id='shop_province'
                        name='shop_province'
                        className='form-control'
                        onChange={(e) => {
                          setSelect_province(e.target.value);
                          setSelect_amphur('');
                          setSelect_tambol('');
                          setSelect_postcode('');
                        }}
                        value={select_province}
                        required
                      >
                        <option value=''>เลือกจังหวัด</option>
                        {sortedProvinces.map((item) => (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      <div className='invalid-feedback'>กรุณาเลือกจังหวัด</div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-4'>
                    <div className='form-group'>
                      <label htmlFor='shop_district'>เขต/อำเภอ</label>
                      <select
                        id='shop_district'
                        name='shop_district'
                        className='form-control'
                        onChange={(e) => {
                          setSelect_amphur(e.target.value);
                          setSelect_tambol('');
                          setSelect_postcode('');
                        }}
                        value={select_amphur}
                        required
                      >
                        <option value=''>เลือกเขต/อำเภอ</option>
                        {list_amphur.map((item) => (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      <div className='invalid-feedback'>กรุณาเลือกเขต/อำเภอ</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12 col-sm-4'>
                    <div className='form-group'>
                      <label htmlFor='shop_subdistrict'>แขวง/ตำบล</label>
                      <select
                        id='shop_subdistrict'
                        name='shop_subdistrict'
                        className='form-control'
                        onChange={(e) => {
                          setSelect_tambol(e.target.value);
                        }}
                        value={select_tambol}
                        required
                      >
                        <option value=''>เลือกแขวง/ตำบล</option>
                        {list_tambol.map((item) => (
                          <option value={item.name_th} key={item}>
                            {item.name_th}
                          </option>
                        ))}
                      </select>
                      <div className='invalid-feedback'>กรุณาเลือกแขวง/ตำบล</div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-4'>
                    <div className='form-group'>
                      <label htmlFor='shop_postcode'>รหัสไปรษณีย์</label>
                      <select
                        id='shop_postcode'
                        name='shop_postcode'
                        className='form-control'
                        onChange={(e) => {
                          setSelect_postcode(e.target.value);
                        }}
                        value={select_postcode}
                        required
                      >
                        <option value=''>เลือกรหัสไปรษณีย์</option>
                        {list_tambol
                          .filter((tambol) => tambol.name_th === select_tambol)
                          .map((item) => (
                            <option value={item.zip_code} key={item.zip_code}>
                              {item.zip_code}
                            </option>
                          ))}
                      </select>
                      <div className='invalid-feedback'>กรุณาเลือกรหัสไปรษณีย์</div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-4'>
                    <div className='form-group'>
                      <label htmlFor='shop_telno'>เบอร์ร้านขายยา</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='shop_telno'
                        name='shop_telno'
                        placeholder='กรอกเบอร์ร้านขายยา'
                        value={phone_format}
                        onChange={(e) => {
                          fillphone(e.target.value);
                        }}
                        autoComplete='new-off'
                        minLength='5'
                        required
                      />
                      <div className='invalid-feedback'>กรุณากรอกเบอร์ร้านขายยา</div>
                    </div>
                  </div>
                </div>
              </form>

              <form
                onSubmit={(e) => e.preventDefault()}
                id='form-signup-p3'
                className='signup-page'
                style={box_signup_stylep3}
              >
                <div className='row'>
                  <div className='col-12'>
                    <div className='form-group opt-mobile-input'>
                      <label htmlFor='OTPMobileNo'>เบอร์โทรศัพท์</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='OTPMobileNo'
                        name='OTPMobileNo'
                        placeholder='กรอกเบอร์โทรศัพท์'
                        value={otp_phone_format}
                        onChange={(e) => {
                          fillotp_phone(e.target.value);
                        }}
                        autoComplete='new-off'
                        minLength='12'
                        maxLength='12'
                        required
                      />
                      <div className='invalid-feedback'>กรุณากรอกเบอร์โทรศัพท์</div>
                    </div>
                  </div>
                </div>
              </form>

              <form
                onSubmit={(e) => e.preventDefault()}
                id='form-signup-p4'
                className='signup-page'
                style={box_signup_stylep4}
              >
                <div className='row'>
                  <div className='col-12'>
                    <div className='form-group opt-mobile-input'>
                      <label htmlFor='OTPConfirm'>OTP</label>
                      <input
                        type='text'
                        className='form-control text-dark'
                        id='OTPConfirm'
                        name='OTPConfirm'
                        placeholder='OTP'
                        value={otp_code_format}
                        onChange={(e) => {
                          fillotp_code(e.target.value);
                        }}
                        autoComplete='new-off'
                        minLength='6'
                        maxLength='6'
                        required
                      />
                      <div className='invalid-feedback'>กรุณากรอกรหัส OTP</div>
                    </div>
                  </div>
                </div>
                {otp_refcode !== '' ? (
                  <>
                    <p className='text-center mt-2'>Ref Code : {otp_refcode}</p>
                    {otp_expire !== '' ? getOTPexpire() : null}
                  </>
                ) : null}
              </form>

              <form
                onSubmit={(e) => e.preventDefault()}
                id='form-signup-p5'
                className='signup-page'
                style={box_signup_stylep5}
              >
                <div className='row mb-4'>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label htmlFor='permit_type'>
                        <strong>ประเภทใบอนุญาตของร้านค้า</strong>
                      </label>
                      <select
                        id='permit_type'
                        className='form-control text-dark'
                        value={permit_type_selected}
                        onChange={(e) => setPermit_type_selected(e.target.value)}
                        required
                      >
                        <option value=''>-- กรุณาเลือกประเภทใบอนุญาต --</option>
                        <option value='ขย. 5 ใบอนุญาตขายยาแผนปัจจุบัน'>
                          ขย. 5 ใบอนุญาตขายยาแผนปัจจุบัน
                        </option>
                        <option value='ขย. 6 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จฯ'>
                          ขย. 6 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จฯ
                        </option>
                        <option value='ขย. 7 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จสำหรับสัตว์'>
                          ขย. 7 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จสำหรับสัตว์
                        </option>
                        <option value='ขย. 8 ใบอนุญาตขายส่งยาแผนปัจจุบัน'>
                          ขย. 8 ใบอนุญาตขายส่งยาแผนปัจจุบัน
                        </option>
                        <option value='สพ. 7 ใบอนุญาตให้ประกอบกิจการสถานพยาบาล'>
                          สพ. 7 ใบอนุญาตให้ประกอบกิจการสถานพยาบาล
                        </option>
                        <option value='สพส. 4 ใบอนุญาตให้ประกอบกิจการสถานพยาบาลสัตว์'>
                          สพส. 4 ใบอนุญาตให้ประกอบกิจการสถานพยาบาลสัตว์
                        </option>
                        <option value='สน.4 ใบอนุญาต นำเข้า เครื่องมือแพทย์'>
                          สน.4 ใบอนุญาต นำเข้า เครื่องมือแพทย์
                        </option>
                        <option value='ส.ผ.4 ใบอนุญาต ผลิต เครื่องมือแพทย์'>
                          ส.ผ.4 ใบอนุญาต ผลิต เครื่องมือแพทย์
                        </option>
                        <option value='ใบ อย. ใบอนุญาต ผลิตอาหารเสริม ตัวอย่าง: 10-1-00165-5-0023'>
                          ใบ อย. ใบอนุญาต ผลิตอาหารเสริม ตัวอย่าง: 10-1-00165-5-0023
                        </option>
                        <option value='ใบ อย. ใบอนุญาต ผลิตอาหาร ตัวอย่าง: 10-1-00165-5-0023'>
                          ใบ อย. ใบอนุญาต ผลิตอาหาร ตัวอย่าง: 10-1-00165-5-0023
                        </option>
                        <option value='ใบ อย. ใบอนุญาต ผลิตภัณฑ์พื้นบ้าน สมุนไพร G 1XX/XX'>
                          ใบ อย. ใบอนุญาต ผลิตภัณฑ์พื้นบ้าน สมุนไพร G 1XX/XX
                        </option>
                      </select>
                      <div className='invalid-feedback'>กรุณาเลือกประเภทใบอนุญาต</div>
                    </div>
                  </div>
                </div>

                <div className='doc-upload-grid'>
                  {/* File 1: License */}
                  <div
                    className={`doc-upload-item ${dragActive.file1 ? 'drag-active' : ''} ${docPreviews.file1 ? 'has-file' : ''}`}
                    onDragEnter={(e) => handleDrag('file1', e)}
                    onDragOver={(e) => handleDrag('file1', e)}
                    onDragLeave={(e) => handleDrag('file1', e)}
                    onDrop={(e) => handleDrop('file1', e)}
                  >
                    <label className='doc-label'>
                      <i className='mdi mdi-file-document-outline mr-2'></i>
                      {permit_type_selected !== '' ? (
                        <strong>{permit_type_selected}</strong>
                      ) : (
                        'ใบอนุญาต ขายยา(ขย.5) / สพ.7 / สถานประกอบการเพื่อสุขภาพ'
                      )}
                    </label>

                    {!docPreviews.file1 ? (
                      <div
                        className='dragzone-content'
                        onClick={() => document.getElementById('customFile1').click()}
                      >
                        <i className='fas fa-cloud-upload-alt upload-icon'></i>
                        <p className='drag-hint'>
                          ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                        </p>
                        <p className='file-types-hint'>รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)</p>
                      </div>
                    ) : (
                      <div className='preview-content'>
                        {docPreviews.file1.type === 'image' ? (
                          <div className='preview-thumbnail'>
                            <img src={docPreviews.file1.url} alt='Preview 1' />
                          </div>
                        ) : (
                          <div className='preview-icon-wrapper'>
                            <i className='far fa-file-pdf pdf-icon'></i>
                          </div>
                        )}
                        <div className='file-details'>
                          <p className='file-name'>{docPreviews.file1.name}</p>
                          <p className='file-size'>
                            {(docPreviews.file1.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                        <button
                          type='button'
                          className='btn-remove-file'
                          onClick={() => removeFile('file1')}
                        >
                          <i className='fas fa-times'></i> ลบ
                        </button>
                      </div>
                    )}

                    <input
                      type='file'
                      id='customFile1'
                      style={{ display: 'none' }}
                      accept='.png, .jpg, .jpeg, .pdf'
                      onChange={(e) => handleFileChange('file1', e.target.files[0])}
                    />
                  </div>

                  {/* File 2: Commercial Registration */}
                  <div
                    className={`doc-upload-item ${dragActive.file2 ? 'drag-active' : ''} ${docPreviews.file2 ? 'has-file' : ''}`}
                    onDragEnter={(e) => handleDrag('file2', e)}
                    onDragOver={(e) => handleDrag('file2', e)}
                    onDragLeave={(e) => handleDrag('file2', e)}
                    onDrop={(e) => handleDrop('file2', e)}
                  >
                    <label className='doc-label'>
                      <i className='mdi mdi-store-outline mr-2'></i>
                      ทะเบียนพาณิชย์ / หนังสือรับรองธุรกิจ
                    </label>

                    {!docPreviews.file2 ? (
                      <div
                        className='dragzone-content'
                        onClick={() => document.getElementById('customFile2').click()}
                      >
                        <i className='fas fa-cloud-upload-alt upload-icon'></i>
                        <p className='drag-hint'>
                          ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                        </p>
                        <p className='file-types-hint'>รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)</p>
                      </div>
                    ) : (
                      <div className='preview-content'>
                        {docPreviews.file2.type === 'image' ? (
                          <div className='preview-thumbnail'>
                            <img src={docPreviews.file2.url} alt='Preview 2' />
                          </div>
                        ) : (
                          <div className='preview-icon-wrapper'>
                            <i className='far fa-file-pdf pdf-icon'></i>
                          </div>
                        )}
                        <div className='file-details'>
                          <p className='file-name'>{docPreviews.file2.name}</p>
                          <p className='file-size'>
                            {(docPreviews.file2.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                        <button
                          type='button'
                          className='btn-remove-file'
                          onClick={() => removeFile('file2')}
                        >
                          <i className='fas fa-times'></i> ลบ
                        </button>
                      </div>
                    )}

                    <input
                      type='file'
                      id='customFile2'
                      style={{ display: 'none' }}
                      accept='.png, .jpg, .jpeg, .pdf'
                      onChange={(e) => handleFileChange('file2', e.target.files[0])}
                    />
                  </div>

                  {/* File 3: Identity Card */}
                  <div
                    className={`doc-upload-item ${dragActive.file3 ? 'drag-active' : ''} ${docPreviews.file3 ? 'has-file' : ''}`}
                    onDragEnter={(e) => handleDrag('file3', e)}
                    onDragOver={(e) => handleDrag('file3', e)}
                    onDragLeave={(e) => handleDrag('file3', e)}
                    onDrop={(e) => handleDrop('file3', e)}
                  >
                    <label className='doc-label'>
                      <i className='mdi mdi-account-card-details-outline mr-2'></i>
                      บัตรประชาชนผู้มีอำนาจลงนาม
                    </label>

                    {!docPreviews.file3 ? (
                      <div
                        className='dragzone-content'
                        onClick={() => document.getElementById('customFile3').click()}
                      >
                        <i className='fas fa-cloud-upload-alt upload-icon'></i>
                        <p className='drag-hint'>
                          ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                        </p>
                        <p className='file-types-hint'>รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)</p>
                      </div>
                    ) : (
                      <div className='preview-content'>
                        {docPreviews.file3.type === 'image' ? (
                          <div className='preview-thumbnail'>
                            <img src={docPreviews.file3.url} alt='Preview 3' />
                          </div>
                        ) : (
                          <div className='preview-icon-wrapper'>
                            <i className='far fa-file-pdf pdf-icon'></i>
                          </div>
                        )}
                        <div className='file-details'>
                          <p className='file-name'>{docPreviews.file3.name}</p>
                          <p className='file-size'>
                            {(docPreviews.file3.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                        <button
                          type='button'
                          className='btn-remove-file'
                          onClick={() => removeFile('file3')}
                        >
                          <i className='fas fa-times'></i> ลบ
                        </button>
                      </div>
                    )}

                    <input
                      type='file'
                      id='customFile3'
                      style={{ display: 'none' }}
                      accept='.png, .jpg, .jpeg, .pdf'
                      onChange={(e) => handleFileChange('file3', e.target.files[0])}
                    />
                  </div>

                  {/* File 4: Bank Account book */}
                  <div
                    className={`doc-upload-item ${dragActive.file4 ? 'drag-active' : ''} ${docPreviews.file4 ? 'has-file' : ''}`}
                    onDragEnter={(e) => handleDrag('file4', e)}
                    onDragOver={(e) => handleDrag('file4', e)}
                    onDragLeave={(e) => handleDrag('file4', e)}
                    onDrop={(e) => handleDrop('file4', e)}
                  >
                    <label className='doc-label'>
                      <i className='mdi mdi-bank-outline mr-2'></i>
                      หน้าสมุดบัญชีธนาคาร (Bookbank)
                    </label>

                    {!docPreviews.file4 ? (
                      <div
                        className='dragzone-content'
                        onClick={() => document.getElementById('customFile4').click()}
                      >
                        <i className='fas fa-cloud-upload-alt upload-icon'></i>
                        <p className='drag-hint'>
                          ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                        </p>
                        <p className='file-types-hint'>รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)</p>
                      </div>
                    ) : (
                      <div className='preview-content'>
                        {docPreviews.file4.type === 'image' ? (
                          <div className='preview-thumbnail'>
                            <img src={docPreviews.file4.url} alt='Preview 4' />
                          </div>
                        ) : (
                          <div className='preview-icon-wrapper'>
                            <i className='far fa-file-pdf pdf-icon'></i>
                          </div>
                        )}
                        <div className='file-details'>
                          <p className='file-name'>{docPreviews.file4.name}</p>
                          <p className='file-size'>
                            {(docPreviews.file4.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                        <button
                          type='button'
                          className='btn-remove-file'
                          onClick={() => removeFile('file4')}
                        >
                          <i className='fas fa-times'></i> ลบ
                        </button>
                      </div>
                    )}

                    <input
                      type='file'
                      id='customFile4'
                      style={{ display: 'none' }}
                      accept='.png, .jpg, .jpeg, .pdf'
                      onChange={(e) => handleFileChange('file4', e.target.files[0])}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className='box-signup-bottom'>
              {box_signup_submit === true ? (
                <button
                  type='button'
                  className='btn meya-btn-primary btn-center'
                  id='button-submit'
                  onClick={() => {
                    signup_submit();
                  }}
                >
                  ลงทะเบียน
                </button>
              ) : null}
              {box_signup_next === true ? (
                <button
                  type='button'
                  className='btn meya-btn-primary btn-center'
                  id='button-next'
                  onClick={() => {
                    signup_next();
                  }}
                >
                  ถัดไป
                </button>
              ) : null}
              {box_signup_haveaccount === true ? (
                <p className='noaccount text-center mt-3' id='haveaccount'>
                  มีบัญชีแล้ว?{' '}
                  <Link
                    to=''
                    onClick={() => {
                      open_signin();
                    }}
                  >
                    เข้าสู่ระบบ
                  </Link>
                </p>
              ) : null}
              {box_signup_previous === true ? (
                <p
                  className='signup-back text-center mt-3'
                  id='button-back'
                  onClick={() => {
                    signup_previous();
                  }}
                >
                  ย้อนกลับ
                </p>
              ) : null}
            </div>
          </div>
        ) : null}
        {box_signup_doc === true ? (
          <div className='box-signup'>
            <div
              className='closeicon'
              onClick={() => {
                setBox_signup_doc(false);
              }}
            >
              <i className='mdi mdi-window-close'></i>
            </div>
            <h6 className='text-center'>เอกสารสำคัญ</h6>
            <p className='text-center text-danger'>
              บัญชีผู้ใช้งานของท่าน ไม่มีเอกสารสำคัญ กรุณาแนบเอกสารเพื่อขออนุญาตซื้อขายสินค้าในเว็บ
              มียา.com
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className='signup-form'
              id='form-submitdoc'
              action=''
              method='POST'
              encType='multipart/form-data'
            >
              <div className='box-signup-content'>
                <div className='doc-upload-grid'>
                  <div className='doc-upload-item'>
                    <label className='doc-label' htmlFor='customFile1-resumit'>
                      <i className='mdi mdi-file-document-outline mr-2'></i>
                      ใบอนุญาต ขายยา(ขย.5)/ สถานพยาบาล(สพ7) / ใบอนุญาตสถานประกอบการเพื่อสุขภาพ
                    </label>
                    <div className='file-input-wrapper'>
                      <input
                        type='file'
                        className='form-control'
                        id='customFile1-resumit'
                        name='customFile1'
                        accept='.png, .jpg, .jpeg, .pdf'
                        required
                      />
                    </div>
                    <div className='invalid-feedback'>กรุณาเลือกไฟล์แนบ</div>
                  </div>

                  <div className='doc-upload-item'>
                    <label className='doc-label' htmlFor='customFile2-resumit'>
                      <i className='mdi mdi-store-outline mr-2'></i>
                      ทะเบียนพาณิชย์
                    </label>
                    <div className='file-input-wrapper'>
                      <input
                        type='file'
                        className='form-control'
                        id='customFile2-resumit'
                        name='customFile2'
                        accept='.png, .jpg, .jpeg, .pdf'
                        required
                      />
                    </div>
                    <div className='invalid-feedback'>กรุณาเลือกไฟล์แนบ</div>
                  </div>

                  <div className='doc-upload-item'>
                    <label className='doc-label' htmlFor='customFile3-resumit'>
                      <i className='mdi mdi-account-card-details-outline mr-2'></i>
                      บัตรประชาชน
                    </label>
                    <div className='file-input-wrapper'>
                      <input
                        type='file'
                        className='form-control'
                        id='customFile3-resumit'
                        name='customFile3'
                        accept='.png, .jpg, .jpeg, .pdf'
                        required
                      />
                    </div>
                    <div className='invalid-feedback'>กรุณาเลือกไฟล์แนบ</div>
                  </div>

                  <div className='doc-upload-item'>
                    <label className='doc-label' htmlFor='customFile4-resumit'>
                      <i className='mdi mdi-bank-outline mr-2'></i>
                      บัญชีรับเงิน
                    </label>
                    <div className='file-input-wrapper'>
                      <input
                        type='file'
                        className='form-control'
                        id='customFile4-resumit'
                        name='customFile4'
                        accept='.png, .jpg, .jpeg, .pdf'
                        required
                      />
                    </div>
                    <div className='invalid-feedback'>กรุณาเลือกไฟล์แนบ</div>
                  </div>
                </div>
              </div>
            </form>

            <div className='box-signup-bottom'>
              <button
                type='button'
                className='btn meya-btn-primary btn-center'
                id='button-submit'
                onClick={() => {
                  signup_submit_doc();
                }}
              >
                ยืนยัน แนบเอกสาร
              </button>
            </div>
          </div>
        ) : null}
        {box_signin === true ? (
          <div className='box-signin'>
            <div
              className='closeicon'
              onClick={() => {
                setBox_signin(false);
              }}
            >
              <i className='mdi mdi-window-close'></i>
            </div>
            <h6 className=''>เข้าสู่ระบบ</h6>
            <p className=''>เข้าสู่ระบบเพื่อเริ่มใช้งานบริการของ มียา.com</p>
            <form onSubmit={(e) => e.preventDefault()} className='mt-4' id='accesspanel'>
              <div className='form-group'>
                <label className='label-with-icon' htmlFor='signin_email'>
                  <span className='label-icon' aria-hidden='true'>
                    <i className='mdi mdi-email'></i>
                  </span>
                  อีเมล
                </label>
                <input
                  type='email'
                  className='form-control'
                  id='signin_email'
                  name='signin_email'
                  placeholder='กรอกอีเมล'
                  value={remember_me.user}
                  onChange={(e) => {
                    handlechange_login('user', e.target.value);
                  }}
                  required
                />
              </div>
              <div className='form-group'>
                <label className='label-with-icon' htmlFor='signin_password'>
                  <span className='label-icon' aria-hidden='true'>
                    <i className='mdi mdi-lock'></i>
                  </span>
                  รหัสผ่าน
                </label>
                <div className='input-group mb-1 font-th'>
                  <input
                    type={login_eye_type}
                    className='form-control'
                    id='signin_password'
                    name='signin_password'
                    placeholder='กรอกรหัสผ่าน'
                    value={remember_me.pass}
                    onChange={(e) => {
                      handlechange_login('pass', e.target.value);
                    }}
                    required
                  />
                  <div className='d-flex'>
                    <span
                      className='btn password-toggle-icon'
                      onClick={() => setLogin_eye(!login_eye)}
                    >
                      <i className={login_eye ? 'fe-eye-off' : 'fe-eye'}></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className='passwordmanage'>
                <div className='form-check'>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    id='remember'
                    checked={remember_me.rem}
                    onChange={(e) => {
                      handlechange_login('rem', e.target.checked);
                    }}
                  />
                  <label className='form-check-label' htmlFor='remember'>
                    จดจำฉันบนอุปกรณ์นี้
                  </label>
                </div>
                <Link
                  to=''
                  onClick={() => {
                    open_forgot();
                  }}
                >
                  ลืมรหัสผ่าน?
                </Link>
              </div>
              <button
                type='button'
                className='btn meya-btn-primary btn-center'
                onClick={() => {
                  handle_login();
                }}
                style={{ marginTop: '60px', borderRadius: '40px' }}
              >
                เข้าสู่ระบบ
              </button>
            </form>
            <p className='noaccount text-center mt-3'>
              ยังไม่มีบัญชีใช่ไหม?{' '}
              <Link
                to=''
                onClick={() => {
                  open_register();
                }}
              >
                ลงทะเบียนที่นี่
              </Link>
            </p>
          </div>
        ) : null}
        {box_forgot === true ? (
          <div className='box-forgot'>
            <div
              className='closeicon'
              onClick={() => {
                setBox_forgot(false);
              }}
            >
              <i className='mdi mdi-window-close'></i>
            </div>
            <h6 className=''>ลืมรหัสผ่าน</h6>
            <p className=''>กรุณากรอกอีเมล ที่ท่านได้สมัครไว้</p>
            <form onSubmit={(e) => e.preventDefault()} className='mt-4' id='forgotpanel'>
              <div className='form-group'>
                <label htmlFor='fotgot_email'>อีเมล</label>
                <input
                  type='email'
                  className='form-control'
                  id='fotgot_email'
                  name='fotgot_email'
                  placeholder='กรอกอีเมล'
                  required
                />
                <div className='invalid-feedback' id='email-forgot-feedback'>
                  กรุณากรอกอีเมลที่ท่านได้สมัครไว้
                </div>
              </div>
            </form>
            <button
              type='button'
              className='btn meya-btn-primary btn-center mt-6'
              onClick={() => {
                handle_forgot();
              }}
            >
              ดำเนินการ ขอรีเซ็ตรหัสผ่าน
            </button>
          </div>
        ) : null}
        {box_policy === true ? (
          <div className='box-policy'>
            <div
              className='closeicon'
              onClick={() => {
                setBox_policy(false);
              }}
            >
              <i className='mdi mdi-window-close'></i>
            </div>
            <h6 className=''>เงื่อนไขการใช้บริการ (Terms of Use)</h6>
            <div className='box-term-wrapper'>
              <Policy></Policy>
              <div className='d-flex justify-content-between'>
                <button
                  type='button'
                  className='btn meya-btn-primary btn-center'
                  onClick={() => {
                    setPolicy_read(true);
                    setBox_policy(false);
                  }}
                >
                  ยอมรับเงื่อนไข
                </button>
                <button
                  type='button'
                  className='btn meya-btn-warning btn-center mt-6'
                  onClick={() => {
                    setPolicy_read(false);
                    setBox_policy(false);
                  }}
                >
                  ไม่ยอมรับเงื่อนไข
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      {showSuccessOptionModal && (
        <div className='success-option-backdrop'>
          <div className='success-option-modal'>
            <div className='success-icon-wrapper animate-bounce'>
              <i className='fas fa-check-circle'></i>
            </div>
            <h4>ยืนยันเบอร์โทรศัพท์สำเร็จ 🎉</h4>
            <p className='message-title'>บัญชีผู้ใช้ของคุณลงทะเบียนเบื้องต้นเรียบร้อยแล้ว!</p>
            <p className='message-desc'>
              เพื่อการซื้อขายที่ถูกต้องตามกฎหมายและได้รับความน่าเชื่อถือสูง
              กรุณากรอกข้อมูลร้านขายยาและอัปโหลดเอกสารสำคัญ (ใบอนุญาต ขย.5/สพ.7, ทะเบียนพาณิชย์,
              บัตรประชาชน, บัญชีรับเงิน)
            </p>
            <div className='modal-choices'>
              <button
                type='button'
                className='btn btn-fill-now'
                onClick={() => {
                  setShowSuccessOptionModal(false);
                  setBox_signup_step(4);
                }}
              >
                <i className='fas fa-edit mr-2'></i> กรอกข้อมูลตอนนี้
              </button>
              <button
                type='button'
                className='btn btn-fill-later'
                onClick={() => {
                  setShowSuccessOptionModal(false);
                  signup_submit_later();
                }}
              >
                กรอกภายหลัง
              </button>
            </div>
          </div>
        </div>
      )}

      {showLoginPendingModal && pendingModalMode === 'warning' && (
        <div className='success-option-backdrop'>
          <div className='success-option-modal'>
            <div className='warning-icon-wrapper animate-bounce'>
              <i className='fas fa-exclamation-triangle'></i>
            </div>
            <h4>ข้อมูลร้านค้ายังไม่ครบถ้วน 📋</h4>
            <p
              className='message-desc'
              style={{ marginTop: '15px', color: '#475569', fontSize: '0.92rem' }}
            >
              กรุณากรอกข้อมูลร้านขายยาและอัปโหลดเอกสารสำคัญ
              เพื่อยืนยันตัวตนและเปิดใช้งานร้านค้าของคุณ
            </p>
            <div className='modal-choices' style={{ marginTop: '25px' }}>
              <button
                type='button'
                className='btn btn-fill-now'
                onClick={() => {
                  setPendingModalMode('wizard');
                  setWizardStep(1);
                }}
              >
                <i className='fas fa-edit mr-2'></i> กรอกข้อมูลตอนนี้
              </button>
              <button
                type='button'
                className='btn btn-fill-later'
                onClick={() => {
                  const session = pendingUserInfo || {
                    shop_id: box_signup_docshopid,
                    shop_email: box_signup_docemail,
                    status: 'pending',
                    token: box_signup_doctoken,
                    role: 'guest',
                  };
                  saveToken(session);
                  props.callback_signin(session);
                  setShowLoginPendingModal(false);
                  setPendingUserInfo(null);
                }}
              >
                ภายหลัง
              </button>
            </div>
          </div>
        </div>
      )}

      {showLoginPendingModal && pendingModalMode === 'wizard' && (
        <div className='success-option-backdrop'>
          <div className='box-signup pending-wizard-modal'>
            <div className='box-signup-header'>
              <div
                className='closeicon'
                onClick={() => {
                  const session = pendingUserInfo || {
                    shop_id: box_signup_docshopid,
                    shop_email: box_signup_docemail,
                    status: 'pending',
                    token: box_signup_doctoken,
                    role: 'guest',
                  };
                  saveToken(session);
                  props.callback_signin(session);
                  setShowLoginPendingModal(false);
                  setPendingUserInfo(null);
                }}
              >
                <i className='mdi mdi-window-close'></i>
              </div>
              <h6 className='text-center'>ข้อมูลร้านขายยา & เอกสารสำคัญ</h6>
              <p className='text-center'>กรุณากรอกข้อมูลเพื่อเปิดใช้งานร้านค้า</p>

              <div className='progressbar-wrapper d-none d-md-block mb-2'>
                <div className='f1-steps' style={{ maxWidth: '400px', margin: '0 auto' }}>
                  <div className='f1-progress' style={{ left: '25%', right: '25%', height: '3px' }}>
                    <div
                      className='f1-progress-line'
                      style={{ width: wizardStep === 1 ? '0%' : '100%' }}
                    ></div>
                  </div>
                  <div className={`f1-step ${wizardStep === 1 ? 'active' : ''}`}>
                    <p>ข้อมูลร้านขายยา</p>
                    <div className='f1-step-icon'>
                      <i className='fas fa-store'></i>
                    </div>
                  </div>
                  <div className={`f1-step ${wizardStep === 2 ? 'active' : ''}`}>
                    <p>เอกสารสำคัญ</p>
                    <div className='f1-step-icon'>
                      <i className='far fa-file-alt'></i>
                    </div>
                  </div>
                </div>
              </div>

              <h5 className='font-size-18 text-dark font-th mt-3 text-center'>
                ขั้นตอนที่ {wizardStep} :{' '}
                {wizardStep === 1 ? 'กรอกข้อมูลร้านขายยา' : 'ประเภทใบอนุญาตและอัปโหลดเอกสาร'}
              </h5>
            </div>

            <div className='box-signup-content'>
              {wizardStep === 1 ? (
                <form
                  onSubmit={(e) => e.preventDefault()}
                  id='wizard-form-step1'
                  className='signup-page'
                >
                  <div className='row'>
                    <div className='col-12 col-sm-6'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_name'>ชื่อร้าน หรือ Username</label>
                        <input
                          type='text'
                          className='form-control text-dark'
                          id='wizard_shop_name'
                          name='wizard_shop_name'
                          placeholder='กรอกชื่อร้าน หรือ Username'
                          value={wizard_shop_name}
                          onChange={(e) => setWizard_shop_name(e.target.value)}
                          autoComplete='new-off'
                          minLength='5'
                          required
                        />
                        <div className='invalid-feedback'>อย่างน้อย 5 ตัวอักษร</div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-6'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_address'>ที่อยู่</label>
                        <input
                          type='text'
                          className='form-control text-dark'
                          id='wizard_shop_address'
                          name='wizard_shop_address'
                          placeholder='กรอกที่อยู่'
                          value={wizard_shop_address}
                          onChange={(e) => setWizard_shop_address(e.target.value)}
                          autoComplete='new-off'
                          required
                        />
                        <div className='invalid-feedback'>กรุณากรอกที่อยู่ร้าน</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 col-sm-4'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_province'>จังหวัด</label>
                        <select
                          id='wizard_shop_province'
                          name='wizard_shop_province'
                          className='form-control'
                          onChange={(e) => {
                            setWizard_select_province(e.target.value);
                            setWizard_select_amphur('');
                            setWizard_select_tambol('');
                            setWizard_select_postcode('');
                          }}
                          value={wizard_select_province}
                          required
                        >
                          <option value=''>เลือกจังหวัด</option>
                          {sortedProvinces.map((item) => (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                        <div className='invalid-feedback'>กรุณาเลือกจังหวัด</div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-4'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_district'>เขต/อำเภอ</label>
                        <select
                          id='wizard_shop_district'
                          name='wizard_shop_district'
                          className='form-control'
                          onChange={(e) => {
                            setWizard_select_amphur(e.target.value);
                            setWizard_select_tambol('');
                            setWizard_select_postcode('');
                          }}
                          value={wizard_select_amphur}
                          required
                        >
                          <option value=''>เลือกเขต/อำเภอ</option>
                          {wizard_list_amphur.map((item) => (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                        <div className='invalid-feedback'>กรุณาเลือกเขต/อำเภอ</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 col-sm-4'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_subdistrict'>แขวง/ตำบล</label>
                        <select
                          id='wizard_shop_subdistrict'
                          name='wizard_shop_subdistrict'
                          className='form-control'
                          onChange={(e) => {
                            setWizard_select_tambol(e.target.value);
                          }}
                          value={wizard_select_tambol}
                          required
                        >
                          <option value=''>เลือกแขวง/ตำบล</option>
                          {wizard_list_tambol.map((item) => (
                            <option value={item.name_th} key={item}>
                              {item.name_th}
                            </option>
                          ))}
                        </select>
                        <div className='invalid-feedback'>กรุณาเลือกแขวง/ตำบล</div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-4'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_postcode'>รหัสไปรษณีย์</label>
                        <select
                          id='wizard_shop_postcode'
                          name='wizard_shop_postcode'
                          className='form-control'
                          onChange={(e) => {
                            setWizard_select_postcode(e.target.value);
                          }}
                          value={wizard_select_postcode}
                          required
                        >
                          <option value=''>เลือกรหัสไปรษณีย์</option>
                          {wizard_list_tambol
                            .filter((tambol) => tambol.name_th === wizard_select_tambol)
                            .map((item) => (
                              <option value={item.zip_code} key={item.zip_code}>
                                {item.zip_code}
                              </option>
                            ))}
                        </select>
                        <div className='invalid-feedback'>กรุณาเลือกรหัสไปรษณีย์</div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-4'>
                      <div className='form-group'>
                        <label htmlFor='wizard_shop_telno'>เบอร์ร้านขายยา</label>
                        <input
                          type='text'
                          className='form-control text-dark'
                          id='wizard_shop_telno'
                          name='wizard_shop_telno'
                          placeholder='กรอกเบอร์ร้านขายยา'
                          value={wizard_phone_format}
                          onChange={(e) => {
                            fillwizard_phone(e.target.value);
                          }}
                          autoComplete='new-off'
                          minLength='5'
                          required
                        />
                        <div className='invalid-feedback'>กรุณากรอกเบอร์ร้านขายยา</div>
                      </div>
                    </div>
                  </div>
                </form>
              ) : (
                <form
                  onSubmit={(e) => e.preventDefault()}
                  id='wizard-form-step2'
                  className='signup-page'
                >
                  <div className='row mb-4'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <label htmlFor='wizard_permit_type'>
                          <strong>ประเภทใบอนุญาตของร้านค้า</strong>
                        </label>
                        <select
                          id='wizard_permit_type'
                          className='form-control text-dark'
                          value={wizard_permit_type_selected}
                          onChange={(e) => setWizard_permit_type_selected(e.target.value)}
                          required
                        >
                          <option value=''>-- กรุณาเลือกประเภทใบอนุญาต --</option>
                          <option value='ขย. 5 ใบอนุญาตขายยาแผนปัจจุบัน'>
                            ขย. 5 ใบอนุญาตขายยาแผนปัจจุบัน
                          </option>
                          <option value='ขย. 6 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จฯ'>
                            ขย. 6 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จฯ
                          </option>
                          <option value='ขย. 7 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จสำหรับสัตว์'>
                            ขย. 7 ใบอนุญาตขายยาแผนปัจจุบันเฉพาะยาบรรจุเสร็จสำหรับสัตว์
                          </option>
                          <option value='ขย. 8 ใบอนุญาตขายส่งยาแผนปัจจุบัน'>
                            ขย. 8 ใบอนุญาตขายส่งยาแผนปัจจุบัน
                          </option>
                          <option value='สพ. 7 ใบอนุญาตให้ประกอบกิจการสถานพยาบาล'>
                            สพ. 7 ใบอนุญาตให้ประกอบกิจการสถานพยาบาล
                          </option>
                          <option value='สพส. 4 ใบอนุญาตให้ประกอบกิจการสถานพยาบาลสัตว์'>
                            สพส. 4 ใบอนุญาตให้ประกอบกิจการสถานพยาบาลสัตว์
                          </option>
                          <option value='สน.4 ใบอนุญาต นำเข้า เครื่องมือแพทย์'>
                            สน.4 ใบอนุญาต นำเข้า เครื่องมือแพทย์
                          </option>
                          <option value='ส.ผ.4 ใบอนุญาต ผลิต เครื่องมือแพทย์'>
                            ส.ผ.4 ใบอนุญาต ผลิต เครื่องมือแพทย์
                          </option>
                          <option value='ใบ อย. ใบอนุญาต ผลิตอาหารเสริม ตัวอย่าง: 10-1-00165-5-0023'>
                            ใบ อย. ใบอนุญาต ผลิตอาหารเสริม ตัวอย่าง: 10-1-00165-5-0023
                          </option>
                          <option value='ใบ อย. ใบอนุญาต ผลิตอาหาร ตัวอย่าง: 10-1-00165-5-0023'>
                            ใบ อย. ใบอนุญาต ผลิตอาหาร ตัวอย่าง: 10-1-00165-5-0023
                          </option>
                          <option value='ใบ อย. ใบอนุญาต ผลิตภัณฑ์พื้นบ้าน สมุนไพร G 1XX/XX'>
                            ใบ อย. ใบอนุญาต ผลิตภัณฑ์พื้นบ้าน สมุนไพร G 1XX/XX
                          </option>
                        </select>
                        <div className='invalid-feedback'>กรุณาเลือกประเภทใบอนุญาต</div>
                      </div>
                    </div>
                  </div>

                  <div className='premium-doc-uploader'>
                    {/* Left Panel: Sidebar list of document types */}
                    <div className='doc-uploader-sidebar'>
                      <div className='sidebar-header'>เอกสารทั้งหมด</div>
                      <div className='sidebar-list'>
                        {/* Tab 1: License */}
                        <div
                          className={`sidebar-item ${wizardActiveDocTab === 'file1' ? 'active' : ''} ${wizardDocPreviews.file1 ? 'has-file' : ''}`}
                          onClick={() => setWizardActiveDocTab('file1')}
                        >
                          <div className='item-icon'>
                            <i className='mdi mdi-file-document-outline'></i>
                          </div>
                          <div className='item-info'>
                            <span className='item-title'>
                              {wizard_permit_type_selected !== ''
                                ? wizard_permit_type_selected
                                : 'ใบอนุญาตของร้านค้า'}
                            </span>
                            <span
                              className={`status-badge ${wizardDocPreviews.file1 ? 'uploaded' : 'pending'}`}
                            >
                              {wizardDocPreviews.file1 ? 'อัปโหลดแล้ว' : 'ยังไม่มีไฟล์'}
                            </span>
                          </div>
                        </div>

                        {/* Tab 2: Commercial Registration */}
                        <div
                          className={`sidebar-item ${wizardActiveDocTab === 'file2' ? 'active' : ''} ${wizardDocPreviews.file2 ? 'has-file' : ''}`}
                          onClick={() => setWizardActiveDocTab('file2')}
                        >
                          <div className='item-icon'>
                            <i className='mdi mdi-store-outline'></i>
                          </div>
                          <div className='item-info'>
                            <span className='item-title'>ทะเบียนพาณิชย์ / หนังสือรับรอง</span>
                            <span
                              className={`status-badge ${wizardDocPreviews.file2 ? 'uploaded' : 'pending'}`}
                            >
                              {wizardDocPreviews.file2 ? 'อัปโหลดแล้ว' : 'ยังไม่มีไฟล์'}
                            </span>
                          </div>
                        </div>

                        {/* Tab 3: ID Card */}
                        <div
                          className={`sidebar-item ${wizardActiveDocTab === 'file3' ? 'active' : ''} ${wizardDocPreviews.file3 ? 'has-file' : ''}`}
                          onClick={() => setWizardActiveDocTab('file3')}
                        >
                          <div className='item-icon'>
                            <i className='mdi mdi-account-card-details-outline'></i>
                          </div>
                          <div className='item-info'>
                            <span className='item-title'>บัตรประชาชนผู้มีอำนาจ</span>
                            <span
                              className={`status-badge ${wizardDocPreviews.file3 ? 'uploaded' : 'pending'}`}
                            >
                              {wizardDocPreviews.file3 ? 'อัปโหลดแล้ว' : 'ยังไม่มีไฟล์'}
                            </span>
                          </div>
                        </div>

                        {/* Tab 4: Bookbank */}
                        <div
                          className={`sidebar-item ${wizardActiveDocTab === 'file4' ? 'active' : ''} ${wizardDocPreviews.file4 ? 'has-file' : ''}`}
                          onClick={() => setWizardActiveDocTab('file4')}
                        >
                          <div className='item-icon'>
                            <i className='mdi mdi-bank-outline'></i>
                          </div>
                          <div className='item-info'>
                            <span className='item-title'>สมุดบัญชีธนาคาร (Bookbank)</span>
                            <span
                              className={`status-badge ${wizardDocPreviews.file4 ? 'uploaded' : 'pending'}`}
                            >
                              {wizardDocPreviews.file4 ? 'อัปโหลดแล้ว' : 'ยังไม่มีไฟล์'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Panel: Large drag-and-drop & preview area */}
                    <div className='doc-uploader-preview-panel'>
                      {/* Active Tab 1: License */}
                      {wizardActiveDocTab === 'file1' && (
                        <div
                          className={`doc-upload-item ${wizardDragActive.file1 ? 'drag-active' : ''} ${wizardDocPreviews.file1 ? 'has-file' : ''}`}
                          onDragEnter={(e) => handleWizardDrag('file1', e)}
                          onDragOver={(e) => handleWizardDrag('file1', e)}
                          onDragLeave={(e) => handleWizardDrag('file1', e)}
                          onDrop={(e) => handleWizardDrop('file1', e)}
                          onClick={() =>
                            !wizardDocPreviews.file1 &&
                            document.getElementById('wizardFile1').click()
                          }
                          style={{ minHeight: '340px' }}
                        >
                          <div className='upload-panel-header'>
                            <i className='mdi mdi-file-document-outline mr-2'></i>
                            {wizard_permit_type_selected !== '' ? (
                              <strong>{wizard_permit_type_selected}</strong>
                            ) : (
                              'ใบอนุญาต ขายยา(ขย.5) / สพ.7 / สถานประกอบการเพื่อสุขภาพ'
                            )}
                          </div>

                          {!wizardDocPreviews.file1 ? (
                            <div className='dragzone-content'>
                              <i className='fas fa-cloud-upload-alt upload-icon'></i>
                              <p className='drag-hint'>
                                ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                              </p>
                              <p className='file-types-hint'>
                                รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)
                              </p>
                            </div>
                          ) : (
                            <div className='preview-content-vertical'>
                              {wizardDocPreviews.file1.type === 'image' ? (
                                <div className='preview-image-large'>
                                  <img src={wizardDocPreviews.file1.url} alt='Preview 1' />
                                </div>
                              ) : (
                                <div className='preview-pdf-large'>
                                  <i className='far fa-file-pdf pdf-icon'></i>
                                  <p>เอกสาร PDF</p>
                                </div>
                              )}
                              <div className='file-details-row'>
                                <div className='details-left'>
                                  <p className='file-name'>{wizardDocPreviews.file1.name}</p>
                                  <p className='file-size'>
                                    {(wizardDocPreviews.file1.size / 1024 / 1024).toFixed(2)} MB
                                  </p>
                                </div>
                                <button
                                  type='button'
                                  className='btn-remove-file-premium'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeWizardFile('file1');
                                  }}
                                >
                                  <i className='fas fa-trash-alt'></i> ลบไฟล์
                                </button>
                              </div>
                            </div>
                          )}

                          <input
                            type='file'
                            id='wizardFile1'
                            style={{ display: 'none' }}
                            accept='.png, .jpg, .jpeg, .pdf'
                            onChange={(e) => handleWizardFileChange('file1', e.target.files[0])}
                          />
                        </div>
                      )}

                      {/* Active Tab 2: Commercial Registration */}
                      {wizardActiveDocTab === 'file2' && (
                        <div
                          className={`doc-upload-item ${wizardDragActive.file2 ? 'drag-active' : ''} ${wizardDocPreviews.file2 ? 'has-file' : ''}`}
                          onDragEnter={(e) => handleWizardDrag('file2', e)}
                          onDragOver={(e) => handleWizardDrag('file2', e)}
                          onDragLeave={(e) => handleWizardDrag('file2', e)}
                          onDrop={(e) => handleWizardDrop('file2', e)}
                          onClick={() =>
                            !wizardDocPreviews.file2 &&
                            document.getElementById('wizardFile2').click()
                          }
                          style={{ minHeight: '340px' }}
                        >
                          <div className='upload-panel-header'>
                            <i className='mdi mdi-store-outline mr-2'></i>
                            <strong>ทะเบียนพาณิชย์ / หนังสือรับรองธุรกิจ</strong>
                          </div>

                          {!wizardDocPreviews.file2 ? (
                            <div className='dragzone-content'>
                              <i className='fas fa-cloud-upload-alt upload-icon'></i>
                              <p className='drag-hint'>
                                ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                              </p>
                              <p className='file-types-hint'>
                                รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)
                              </p>
                            </div>
                          ) : (
                            <div className='preview-content-vertical'>
                              {wizardDocPreviews.file2.type === 'image' ? (
                                <div className='preview-image-large'>
                                  <img src={wizardDocPreviews.file2.url} alt='Preview 2' />
                                </div>
                              ) : (
                                <div className='preview-pdf-large'>
                                  <i className='far fa-file-pdf pdf-icon'></i>
                                  <p>เอกสาร PDF</p>
                                </div>
                              )}
                              <div className='file-details-row'>
                                <div className='details-left'>
                                  <p className='file-name'>{wizardDocPreviews.file2.name}</p>
                                  <p className='file-size'>
                                    {(wizardDocPreviews.file2.size / 1024 / 1024).toFixed(2)} MB
                                  </p>
                                </div>
                                <button
                                  type='button'
                                  className='btn-remove-file-premium'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeWizardFile('file2');
                                  }}
                                >
                                  <i className='fas fa-trash-alt'></i> ลบไฟล์
                                </button>
                              </div>
                            </div>
                          )}

                          <input
                            type='file'
                            id='wizardFile2'
                            style={{ display: 'none' }}
                            accept='.png, .jpg, .jpeg, .pdf'
                            onChange={(e) => handleWizardFileChange('file2', e.target.files[0])}
                          />
                        </div>
                      )}

                      {/* Active Tab 3: ID Card */}
                      {wizardActiveDocTab === 'file3' && (
                        <div
                          className={`doc-upload-item ${wizardDragActive.file3 ? 'drag-active' : ''} ${wizardDocPreviews.file3 ? 'has-file' : ''}`}
                          onDragEnter={(e) => handleWizardDrag('file3', e)}
                          onDragOver={(e) => handleWizardDrag('file3', e)}
                          onDragLeave={(e) => handleWizardDrag('file3', e)}
                          onDrop={(e) => handleWizardDrop('file3', e)}
                          onClick={() =>
                            !wizardDocPreviews.file3 &&
                            document.getElementById('wizardFile3').click()
                          }
                          style={{ minHeight: '340px' }}
                        >
                          <div className='upload-panel-header'>
                            <i className='mdi mdi-account-card-details-outline mr-2'></i>
                            <strong>บัตรประชาชนผู้มีอำนาจลงนาม</strong>
                          </div>

                          {!wizardDocPreviews.file3 ? (
                            <div className='dragzone-content'>
                              <i className='fas fa-cloud-upload-alt upload-icon'></i>
                              <p className='drag-hint'>
                                ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                              </p>
                              <p className='file-types-hint'>
                                รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)
                              </p>
                            </div>
                          ) : (
                            <div className='preview-content-vertical'>
                              {wizardDocPreviews.file3.type === 'image' ? (
                                <div className='preview-image-large'>
                                  <img src={wizardDocPreviews.file3.url} alt='Preview 3' />
                                </div>
                              ) : (
                                <div className='preview-pdf-large'>
                                  <i className='far fa-file-pdf pdf-icon'></i>
                                  <p>เอกสาร PDF</p>
                                </div>
                              )}
                              <div className='file-details-row'>
                                <div className='details-left'>
                                  <p className='file-name'>{wizardDocPreviews.file3.name}</p>
                                  <p className='file-size'>
                                    {(wizardDocPreviews.file3.size / 1024 / 1024).toFixed(2)} MB
                                  </p>
                                </div>
                                <button
                                  type='button'
                                  className='btn-remove-file-premium'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeWizardFile('file3');
                                  }}
                                >
                                  <i className='fas fa-trash-alt'></i> ลบไฟล์
                                </button>
                              </div>
                            </div>
                          )}

                          <input
                            type='file'
                            id='wizardFile3'
                            style={{ display: 'none' }}
                            accept='.png, .jpg, .jpeg, .pdf'
                            onChange={(e) => handleWizardFileChange('file3', e.target.files[0])}
                          />
                        </div>
                      )}

                      {/* Active Tab 4: Bookbank */}
                      {wizardActiveDocTab === 'file4' && (
                        <div
                          className={`doc-upload-item ${wizardDragActive.file4 ? 'drag-active' : ''} ${wizardDocPreviews.file4 ? 'has-file' : ''}`}
                          onDragEnter={(e) => handleWizardDrag('file4', e)}
                          onDragOver={(e) => handleWizardDrag('file4', e)}
                          onDragLeave={(e) => handleWizardDrag('file4', e)}
                          onDrop={(e) => handleWizardDrop('file4', e)}
                          onClick={() =>
                            !wizardDocPreviews.file4 &&
                            document.getElementById('wizardFile4').click()
                          }
                          style={{ minHeight: '340px' }}
                        >
                          <div className='upload-panel-header'>
                            <i className='mdi mdi-bank-outline mr-2'></i>
                            <strong>หน้าสมุดบัญชีธนาคาร (Bookbank) / เอกสารอื่นๆ</strong>
                          </div>

                          {!wizardDocPreviews.file4 ? (
                            <div className='dragzone-content'>
                              <i className='fas fa-cloud-upload-alt upload-icon'></i>
                              <p className='drag-hint'>
                                ลากและวางไฟล์ หรือ <span>คลิกเพื่ออัปโหลด</span>
                              </p>
                              <p className='file-types-hint'>
                                รองรับ PNG, JPG, JPEG, PDF (สูงสุด 5MB)
                              </p>
                            </div>
                          ) : (
                            <div className='preview-content-vertical'>
                              {wizardDocPreviews.file4.type === 'image' ? (
                                <div className='preview-image-large'>
                                  <img src={wizardDocPreviews.file4.url} alt='Preview 4' />
                                </div>
                              ) : (
                                <div className='preview-pdf-large'>
                                  <i className='far fa-file-pdf pdf-icon'></i>
                                  <p>เอกสาร PDF</p>
                                </div>
                              )}
                              <div className='file-details-row'>
                                <div className='details-left'>
                                  <p className='file-name'>{wizardDocPreviews.file4.name}</p>
                                  <p className='file-size'>
                                    {(wizardDocPreviews.file4.size / 1024 / 1024).toFixed(2)} MB
                                  </p>
                                </div>
                                <button
                                  type='button'
                                  className='btn-remove-file-premium'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeWizardFile('file4');
                                  }}
                                >
                                  <i className='fas fa-trash-alt'></i> ลบไฟล์
                                </button>
                              </div>
                            </div>
                          )}

                          <input
                            type='file'
                            id='wizardFile4'
                            style={{ display: 'none' }}
                            accept='.png, .jpg, .jpeg, .pdf'
                            onChange={(e) => handleWizardFileChange('file4', e.target.files[0])}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              )}
            </div>

            <div className='box-signup-bottom'>
              {wizardStep === 1 ? (
                <button
                  type='button'
                  className='btn meya-btn-primary btn-center'
                  onClick={() => {
                    var form = document.getElementById('wizard-form-step1');
                    if (form.checkValidity() === false) {
                      form.classList.add('was-validated');
                    } else {
                      form.classList.remove('was-validated');
                      setWizardStep(2);
                    }
                  }}
                >
                  ถัดไป
                </button>
              ) : (
                <button
                  type='button'
                  className='btn meya-btn-primary btn-center'
                  onClick={() => submit_wizard_profile()}
                >
                  ลงทะเบียน / บันทึกข้อมูล
                </button>
              )}

              {wizardStep === 2 && (
                <p
                  className='signup-back text-center mt-3'
                  onClick={() => setWizardStep(1)}
                  style={{ cursor: 'pointer' }}
                >
                  ย้อนกลับ
                </p>
              )}

              {wizardStep === 1 && (
                <p
                  className='signup-back text-center mt-3'
                  onClick={() => {
                    const session = pendingUserInfo || {
                      shop_id: box_signup_docshopid,
                      shop_email: box_signup_docemail,
                      status: 'pending',
                      token: box_signup_doctoken,
                      role: 'guest',
                    };
                    saveToken(session);
                    props.callback_signin(session);
                    setShowLoginPendingModal(false);
                    setPendingUserInfo(null);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  กรอกภายหลัง
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      <ButtonGoto></ButtonGoto>
    </>
  );
}

export default Login;
